var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-application-programming-interface",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-application-programming-interface:not(.animated) .animable {opacity: 0;}svg#freepik_stories-application-programming-interface.animated #freepik--gear-1--inject-195 {animation: 3s Infinite  linear spin;animation-delay: 0s;}svg#freepik_stories-application-programming-interface.animated #elnpzb8q6v19f {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-application-programming-interface.animated #el9yubqwq36s {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0.65s;opacity: 0}svg#freepik_stories-application-programming-interface.animated #el7w24s97z7rg {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 1.3s;opacity: 0}svg#freepik_stories-application-programming-interface.animated #elb15r6eedz3 {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 1.9500000000000002s;opacity: 0}svg#freepik_stories-application-programming-interface.animated #freepik--arrows-2--inject-195 {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-application-programming-interface.animated #elabe9j2mqezw {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-application-programming-interface.animated #el7wxujyzsz1 {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0.65s;opacity: 0}svg#freepik_stories-application-programming-interface.animated #eldeeg6c3qv9g {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 1.3s;opacity: 0}svg#freepik_stories-application-programming-interface.animated #elv15yxtt6et {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 1.9500000000000002s;opacity: 0}svg#freepik_stories-application-programming-interface.animated #freepik--arrows-1--inject-195 {animation: 2.6s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}         @keyframes spin {             from {                 transform: rotate(0);               }               to {                 transform: rotate(360deg);               }         }                 @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-195",
    className: "animable",
    style: {
      transformOrigin: "361.476px 241.941px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.46,265.47s10-178-141-227-227-13-275,33-64,76-119,82-106,16-132,83,7,120,57,153,108-2,154,19,75,56,169,60,97-23,145-65S690.46,405.47,699.46,265.47Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "361.476px 241.941px"
    },
    id: "elq9hb6nb9rps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw22nkx3g41",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.46,265.47s10-178-141-227-227-13-275,33-64,76-119,82-106,16-132,83,7,120,57,153,108-2,154,19,75,56,169,60,97-23,145-65S690.46,405.47,699.46,265.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "361.476px 241.941px"
    },
    className: "animable",
    id: "elx2r5vgsvzxe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-195",
    className: "animable",
    style: {
      transformOrigin: "376.9px 446.5px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M743.58,447H10.22a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H743.58a.5.5,0,0,1,.5.5A.51.51,0,0,1,743.58,447Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "376.9px 446.5px"
    },
    id: "eln5oz8ct8kl8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Codes--inject-195",
    className: "animable",
    style: {
      transformOrigin: "372.315px 179.555px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.62,56h-3.9a1,1,0,1,1,0-1.93h3.9a1,1,0,0,1,0,1.93Zm1,3.49a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,59.48Zm0,4.47a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,64Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,68.41Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,72.87Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,77.33Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,81.79Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,86.25ZM435.18,55a1,1,0,0,0-1-1H424A1,1,0,0,0,424,56h10.25A1,1,0,0,0,435.18,55Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,435.18,59.48Zm0,4.47a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,435.18,64Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,435.18,68.41Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,435.18,72.87Zm12.27,4.46a1,1,0,0,0-1-1H436.24a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,447.45,77.33Zm0,4.46a1,1,0,0,0-1-1H436.24a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,447.45,81.79Zm0,4.46a1,1,0,0,0-1-1H436.24a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,447.45,86.25ZM439.69,55a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,439.69,55ZM443,55a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,443,55Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,446.38,55Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,449.73,55Zm3.34,0A1.12,1.12,0,1,0,452,56.14,1.11,1.11,0,0,0,453.07,55Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,456.42,55ZM439.69,64a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,439.69,64ZM443,64a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,443,64Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,446.38,64Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,449.73,64Zm3.34,0A1.12,1.12,0,1,0,452,65.06,1.12,1.12,0,0,0,453.07,64Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,456.42,64Zm-5.3,12.82A1.12,1.12,0,1,0,450,77.89,1.12,1.12,0,0,0,451.12,76.77Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,454.47,76.77Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.12,1.12,0,0,0,457.81,76.77Zm3.35,0A1.12,1.12,0,1,0,460,77.89,1.12,1.12,0,0,0,461.16,76.77Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,464.5,76.77Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,467.85,76.77ZM451.12,86A1.12,1.12,0,1,0,450,87.09,1.11,1.11,0,0,0,451.12,86Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,454.47,86Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,457.81,86Zm3.35,0A1.12,1.12,0,1,0,460,87.09,1.11,1.11,0,0,0,461.16,86Zm3.34,0a1.12,1.12,0,0,0-2.23,0,1.12,1.12,0,1,0,2.23,0Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,467.85,86Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "441.146px 70.5528px"
    },
    id: "ely0uj4ys8gjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.62,91.68h-3.9a1,1,0,1,1,0-1.92h3.9a1,1,0,1,1,0,1.92Zm1,3.5a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,95.18Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,99.64Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,104.1Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,108.56Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,113Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,117.48Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,121.94Zm14.6-31.22a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,435.18,90.72Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,435.18,95.18Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,435.18,99.64Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,435.18,104.1Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,435.18,108.56ZM447.45,113a1,1,0,0,0-1-1H436.24a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,447.45,113Zm0,4.46a1,1,0,0,0-1-1H436.24a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,447.45,117.48Zm0,4.46a1,1,0,0,0-1-1H436.24a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,447.45,121.94Zm-7.76-31.22a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,439.69,90.72Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,443,90.72Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,446.38,90.72Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,449.73,90.72Zm3.34,0A1.12,1.12,0,1,0,452,91.83,1.12,1.12,0,0,0,453.07,90.72Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,456.42,90.72Zm-16.73,8.92a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,439.69,99.64Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,443,99.64Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,446.38,99.64Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,449.73,99.64Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,453.07,99.64Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,456.42,99.64Zm-5.3,12.83a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,451.12,112.47Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,454.47,112.47Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,457.81,112.47Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,461.16,112.47Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.11,1.11,0,0,0,464.5,112.47Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,467.85,112.47Zm-16.73,9.2a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,451.12,121.67Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,454.47,121.67Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,457.81,121.67Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,461.16,121.67Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.11,1.11,0,0,0,464.5,121.67Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,467.85,121.67Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "441.145px 106.237px"
    },
    id: "elivpqx9gkcus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.62,128.24h-3.9a1,1,0,1,1,0-1.93h3.9a1,1,0,0,1,0,1.93Zm1,3.5a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,131.74Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.93h3.9A1,1,0,0,0,420.58,136.2Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,140.66Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,145.12Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,149.58Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,154Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,420.58,158.5Zm14.6-31.22a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,435.18,127.28Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,435.18,131.74Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,435.18,136.2Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,435.18,140.66Zm0,4.46a1,1,0,0,0-1-1H424a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,435.18,145.12Zm12.27,4.46a1,1,0,0,0-1-1H436.24a1,1,0,1,0,0,1.92h10.25A1,1,0,0,0,447.45,149.58Zm0,4.46a1,1,0,0,0-1-1H436.24a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,447.45,154Zm0,4.46a1,1,0,0,0-1-1H436.24a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,447.45,158.5Zm-7.76-31.22a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,439.69,127.28Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,443,127.28Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,446.38,127.28Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,449.73,127.28Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,453.07,127.28Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,456.42,127.28Zm-16.73,8.92a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,439.69,136.2Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,443,136.2Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,446.38,136.2Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,449.73,136.2Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,453.07,136.2Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,456.42,136.2ZM451.12,149a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,451.12,149Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,454.47,149Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,457.81,149Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,461.16,149Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,464.5,149Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,467.85,149Zm-16.73,9.2a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,451.12,158.22Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,454.47,158.22Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,457.81,158.22Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,461.16,158.22Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,464.5,158.22Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,467.85,158.22Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "441.145px 142.805px"
    },
    id: "elmuu5xk18klo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.54,56h-3.9a1,1,0,0,1,0-1.93h3.9a1,1,0,1,1,0,1.93Zm1,3.49a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,59.48Zm0,4.47a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,64Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,68.41Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,72.87Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,480.51,77.33Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.92h3.9A1,1,0,0,0,480.51,81.79Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,480.51,86.25ZM495.11,55a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,495.11,55Zm0,4.46a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,495.11,59.48Zm0,4.47a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,495.11,64Zm0,4.46a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,495.11,68.41Zm0,4.46a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,495.11,72.87Zm12.26,4.46a1,1,0,0,0-1-1H496.17a1,1,0,1,0,0,1.92h10.24A1,1,0,0,0,507.37,77.33Zm0,4.46a1,1,0,0,0-1-1H496.17a1,1,0,1,0,0,1.92h10.24A1,1,0,0,0,507.37,81.79Zm0,4.46a1,1,0,0,0-1-1H496.17a1,1,0,1,0,0,1.92h10.24A1,1,0,0,0,507.37,86.25ZM499.62,55a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,499.62,55ZM503,55a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,503,55Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,506.31,55Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,509.65,55ZM513,55a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,513,55Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,516.34,55ZM499.62,64a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,499.62,64ZM503,64a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,503,64Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,506.31,64Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,509.65,64ZM513,64a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,513,64Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.11,1.11,0,0,0,516.34,64Zm-5.29,12.82a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,511.05,76.77Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.12,1.12,0,0,0,514.39,76.77Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,517.74,76.77Zm3.34,0A1.12,1.12,0,1,0,520,77.89,1.12,1.12,0,0,0,521.08,76.77Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,524.43,76.77Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,527.78,76.77ZM511.05,86a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,511.05,86Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,514.39,86Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,517.74,86Zm3.34,0A1.12,1.12,0,1,0,520,87.09,1.11,1.11,0,0,0,521.08,86Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,524.43,86Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,527.78,86Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "501.071px 70.55px"
    },
    id: "elbgotj4veaek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.54,92.54h-3.9a1,1,0,1,1,0-1.92h3.9a1,1,0,1,1,0,1.92Zm1,3.5a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.92h3.9A1,1,0,0,0,480.51,96Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,100.5Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,105Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,109.42Zm0,4.47a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,113.89Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,118.35Zm0,4.46a1,1,0,0,0-1-1h-3.9a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,480.51,122.81Zm14.6-31.23a1,1,0,0,0-1-1H483.9a1,1,0,1,0,0,1.92h10.25A1,1,0,0,0,495.11,91.58Zm0,4.46a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,495.11,96Zm0,4.46a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,495.11,100.5Zm0,4.46a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,495.11,105Zm0,4.46a1,1,0,0,0-1-1H483.9a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,495.11,109.42Zm12.26,4.47a1,1,0,0,0-1-1H496.17a1,1,0,1,0,0,1.93h10.24A1,1,0,0,0,507.37,113.89Zm0,4.46a1,1,0,0,0-1-1H496.17a1,1,0,1,0,0,1.93h10.24A1,1,0,0,0,507.37,118.35Zm0,4.46a1,1,0,0,0-1-1H496.17a1,1,0,1,0,0,1.93h10.24A1,1,0,0,0,507.37,122.81Zm-7.75-31.23a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,499.62,91.58Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,503,91.58Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,506.31,91.58Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,509.65,91.58Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,513,91.58Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,516.34,91.58Zm-16.72,8.92a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,499.62,100.5Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,503,100.5Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,506.31,100.5Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,509.65,100.5Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,513,100.5Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,516.34,100.5Zm-5.29,12.83a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,511.05,113.33Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,514.39,113.33Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,517.74,113.33Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,521.08,113.33Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,524.43,113.33Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,527.78,113.33Zm-16.73,9.2a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,511.05,122.53Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,514.39,122.53Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,517.74,122.53Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,521.08,122.53Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,524.43,122.53Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,527.78,122.53Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "501.085px 107.118px"
    },
    id: "eln5n814e899",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,201.79H218.1a1,1,0,1,1,0-1.92H222a1,1,0,1,1,0,1.92Zm1,3.5a1,1,0,0,0-1-1H218.1a1,1,0,1,0,0,1.92H222A1,1,0,0,0,223,205.29Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.92H222A1,1,0,0,0,223,209.75Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,214.21Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,218.67Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,223.13Zm0,4.47a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,227.6Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,232.06Zm14.6-31.23a1,1,0,0,0-1-1H226.36a1,1,0,1,0,0,1.92h10.25A1,1,0,0,0,237.57,200.83Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,237.57,205.29Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,237.57,209.75Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,214.21Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,218.67Zm12.27,4.46a1,1,0,0,0-1-1H238.63a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,249.84,223.13Zm0,4.47a1,1,0,0,0-1-1H238.63a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,249.84,227.6Zm0,4.46a1,1,0,0,0-1-1H238.63a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,249.84,232.06Zm-7.76-31.23A1.12,1.12,0,1,0,241,202,1.11,1.11,0,0,0,242.08,200.83Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,245.43,200.83Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,248.77,200.83Zm3.35,0A1.12,1.12,0,1,0,251,202,1.11,1.11,0,0,0,252.12,200.83Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,255.46,200.83Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,258.81,200.83Zm-16.73,8.92a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,242.08,209.75Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,245.43,209.75Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,248.77,209.75Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,252.12,209.75Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,255.46,209.75Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,258.81,209.75Zm-5.3,12.83a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,253.51,222.58Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,256.86,222.58Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,260.2,222.58Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,263.55,222.58Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,266.89,222.58Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,270.24,222.58Zm-16.73,9.2a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,253.51,231.78Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,256.86,231.78Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,260.2,231.78Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,263.55,231.78Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,266.89,231.78Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,270.24,231.78Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "243.545px 216.35px"
    },
    id: "elecpt0j1u5xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,237.49H218.1a1,1,0,0,1,0-1.93H222a1,1,0,0,1,0,1.93Zm1,3.5a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,241Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,245.45Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.92H222A1,1,0,0,0,223,249.91Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.92H222A1,1,0,0,0,223,254.37Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.92H222A1,1,0,0,0,223,258.83Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,1,0,0,1.92H222A1,1,0,0,0,223,263.29Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,1,0,0,1.92H222A1,1,0,0,0,223,267.75Zm14.6-31.22a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,236.53Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,241Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,245.45Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,1,0,0,1.92h10.25A1,1,0,0,0,237.57,249.91Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,237.57,254.37Zm12.27,4.46a1,1,0,0,0-1-1H238.63a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,249.84,258.83Zm0,4.46a1,1,0,0,0-1-1H238.63a1,1,0,1,0,0,1.92h10.25A1,1,0,0,0,249.84,263.29Zm0,4.46a1,1,0,0,0-1-1H238.63a1,1,0,1,0,0,1.92h10.25A1,1,0,0,0,249.84,267.75Zm-7.76-31.22a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,242.08,236.53Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,245.43,236.53Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,248.77,236.53Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,252.12,236.53Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,255.46,236.53Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,258.81,236.53Zm-16.73,8.92a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,242.08,245.45Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,245.43,245.45Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,248.77,245.45Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,252.12,245.45Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,255.46,245.45Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,258.81,245.45Zm-5.3,12.82a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,253.51,258.27Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,256.86,258.27Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,260.2,258.27Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,263.55,258.27Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,266.89,258.27Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,270.24,258.27Zm-16.73,9.2a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,253.51,267.47Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,256.86,267.47Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,260.2,267.47Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,263.55,267.47Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,266.89,267.47Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,270.24,267.47Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "243.545px 252.055px"
    },
    id: "elchstlumblos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,274.05H218.1a1,1,0,0,1,0-1.93H222a1,1,0,0,1,0,1.93Zm1,3.49a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,277.54Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,282Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,286.46Zm0,4.47a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,290.93Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.93H222A1,1,0,0,0,223,295.39Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.92H222A1,1,0,0,0,223,299.85Zm0,4.46a1,1,0,0,0-1-1H218.1a1,1,0,0,0,0,1.92H222A1,1,0,0,0,223,304.31Zm14.6-31.23a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,273.08Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,277.54Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,282Zm0,4.46a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,286.46Zm0,4.47a1,1,0,0,0-1-1H226.36a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,237.57,290.93Zm12.27,4.46a1,1,0,0,0-1-1H238.63a1,1,0,0,0,0,1.93h10.25A1,1,0,0,0,249.84,295.39Zm0,4.46a1,1,0,0,0-1-1H238.63a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,249.84,299.85Zm0,4.46a1,1,0,0,0-1-1H238.63a1,1,0,0,0,0,1.92h10.25A1,1,0,0,0,249.84,304.31Zm-7.76-31.23A1.12,1.12,0,1,0,241,274.2,1.11,1.11,0,0,0,242.08,273.08Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,245.43,273.08Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,248.77,273.08Zm3.35,0A1.12,1.12,0,1,0,251,274.2,1.12,1.12,0,0,0,252.12,273.08Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,255.46,273.08Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,258.81,273.08ZM242.08,282a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,242.08,282Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,245.43,282Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,248.77,282Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,252.12,282Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,255.46,282Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,258.81,282Zm-5.3,12.83a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,253.51,294.83Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,256.86,294.83Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,260.2,294.83Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,263.55,294.83Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,266.89,294.83Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,270.24,294.83ZM253.51,304a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,253.51,304Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,256.86,304Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,260.2,304Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,263.55,304Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,266.89,304Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,270.24,304Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "243.801px 288.595px"
    },
    id: "el40bulhhjohq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.93,201.79H278a1,1,0,1,1,0-1.92h3.9a1,1,0,1,1,0,1.92Zm1,3.5a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.92h3.9A1,1,0,0,0,282.9,205.29Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.92h3.9A1,1,0,0,0,282.9,209.75Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,282.9,214.21Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,282.9,218.67Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,282.9,223.13Zm0,4.47a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,282.9,227.6Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,282.9,232.06Zm14.6-31.23a1,1,0,0,0-1-1H286.29a1,1,0,0,0,0,1.92h10.24A1,1,0,0,0,297.5,200.83Zm0,4.46a1,1,0,0,0-1-1H286.29a1,1,0,1,0,0,1.92h10.24A1,1,0,0,0,297.5,205.29Zm0,4.46a1,1,0,0,0-1-1H286.29a1,1,0,1,0,0,1.92h10.24A1,1,0,0,0,297.5,209.75Zm0,4.46a1,1,0,0,0-1-1H286.29a1,1,0,0,0,0,1.93h10.24A1,1,0,0,0,297.5,214.21Zm0,4.46a1,1,0,0,0-1-1H286.29a1,1,0,0,0,0,1.93h10.24A1,1,0,0,0,297.5,218.67Zm12.26,4.46a1,1,0,0,0-1-1H298.56a1,1,0,1,0,0,1.93H308.8A1,1,0,0,0,309.76,223.13Zm0,4.47a1,1,0,0,0-1-1H298.56a1,1,0,1,0,0,1.93H308.8A1,1,0,0,0,309.76,227.6Zm0,4.46a1,1,0,0,0-1-1H298.56a1,1,0,1,0,0,1.93H308.8A1,1,0,0,0,309.76,232.06ZM302,200.83a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,302,200.83Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,305.35,200.83Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,308.7,200.83Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,312,200.83Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.11,1.11,0,0,0,315.39,200.83Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,318.73,200.83ZM302,209.75a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,302,209.75Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,305.35,209.75Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,308.7,209.75Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,312,209.75Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,315.39,209.75Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,318.73,209.75Zm-5.29,12.83a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,313.44,222.58Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,316.78,222.58Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,320.13,222.58Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,323.47,222.58Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,326.82,222.58Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.11,1.11,0,0,0,330.16,222.58Zm-16.72,9.2a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,313.44,231.78Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,316.78,231.78Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,320.13,231.78Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,323.47,231.78Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,326.82,231.78Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.11,1.11,0,0,0,330.16,231.78Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "303.44px 216.368px"
    },
    id: "el4cmrfadoryw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.93,238.35H278a1,1,0,1,1,0-1.92h3.9a1,1,0,1,1,0,1.92Zm1,3.5a1,1,0,0,0-1-1H278a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,282.9,241.85Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,282.9,246.31Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,282.9,250.77Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,282.9,255.23Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,1,0,0,1.92h3.9A1,1,0,0,0,282.9,259.69Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.92h3.9A1,1,0,0,0,282.9,264.15Zm0,4.46a1,1,0,0,0-1-1H278a1,1,0,0,0,0,1.93h3.9A1,1,0,0,0,282.9,268.61Zm14.6-31.22a1,1,0,0,0-1-1H286.29a1,1,0,0,0,0,1.92h10.24A1,1,0,0,0,297.5,237.39Zm0,4.46a1,1,0,0,0-1-1H286.29a1,1,0,0,0,0,1.92h10.24A1,1,0,0,0,297.5,241.85Zm0,4.46a1,1,0,0,0-1-1H286.29a1,1,0,0,0,0,1.92h10.24A1,1,0,0,0,297.5,246.31Zm0,4.46a1,1,0,0,0-1-1H286.29a1,1,0,1,0,0,1.92h10.24A1,1,0,0,0,297.5,250.77Zm0,4.46a1,1,0,0,0-1-1H286.29a1,1,0,0,0,0,1.92h10.24A1,1,0,0,0,297.5,255.23Zm12.26,4.46a1,1,0,0,0-1-1H298.56a1,1,0,1,0,0,1.92H308.8A1,1,0,0,0,309.76,259.69Zm0,4.46a1,1,0,0,0-1-1H298.56a1,1,0,1,0,0,1.92H308.8A1,1,0,0,0,309.76,264.15Zm0,4.46a1,1,0,0,0-1-1H298.56a1,1,0,1,0,0,1.93H308.8A1,1,0,0,0,309.76,268.61ZM302,237.39a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,302,237.39Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,305.35,237.39Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,308.7,237.39Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,312,237.39Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,315.39,237.39Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,318.73,237.39ZM302,246.31a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,302,246.31Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,305.35,246.31Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,308.7,246.31Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,312,246.31Zm3.35,0a1.12,1.12,0,1,0-1.12,1.11A1.12,1.12,0,0,0,315.39,246.31Zm3.34,0a1.12,1.12,0,1,0-1.11,1.11A1.12,1.12,0,0,0,318.73,246.31Zm-5.29,12.82a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,313.44,259.13Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,316.78,259.13Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,320.13,259.13Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,323.47,259.13Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,326.82,259.13Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,330.16,259.13Zm-16.72,9.2a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,313.44,268.33Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,316.78,268.33Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,320.13,268.33Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,323.47,268.33Zm3.35,0a1.12,1.12,0,1,0-1.12,1.12A1.12,1.12,0,0,0,326.82,268.33Zm3.34,0a1.12,1.12,0,1,0-1.11,1.12A1.11,1.11,0,0,0,330.16,268.33Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "303.44px 252.918px"
    },
    id: "elf3kd0zknfoc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears-2--inject-195",
    className: "animable",
    style: {
      transformOrigin: "297.93px 182.695px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.3,70v-7.9l-7.89-.88a18.56,18.56,0,0,0-1.94-4.71l5-6.23-5.59-5.59-6.21,5a18.35,18.35,0,0,0-4.69-2l-.88-7.93h-7.91l-.87,7.89a19.31,19.31,0,0,0-4.71,1.94l-6.23-5-5.59,5.59,5,6.21a18.68,18.68,0,0,0-2,4.69l-7.93.88v7.91l7.89.88a18.64,18.64,0,0,0,1.94,4.7l-5,6.23,5.59,5.59,6.21-5a18.68,18.68,0,0,0,4.69,2l.88,7.93H201l.87-7.89a18.56,18.56,0,0,0,4.71-1.94l6.23,5,5.59-5.59-5-6.21a18.68,18.68,0,0,0,2-4.69Zm-26.22,5.42A9.44,9.44,0,1,1,206.51,66,9.43,9.43,0,0,1,197.08,75.43Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "197.08px 65.98px"
    },
    id: "elji7wnj6l6di",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,54.14l-.87-5.23-5.32.29a13.32,13.32,0,0,0-1.81-2.9L249,41.63l-4.32-3.09-3.56,4a12.37,12.37,0,0,0-3.32-.78l-1.46-5.15-5.24.87.3,5.32a12.86,12.86,0,0,0-2.9,1.81L223.79,42l-3.08,4.32,4,3.56a12.76,12.76,0,0,0-.78,3.32l-5.15,1.46.87,5.24,5.33-.3a12.48,12.48,0,0,0,1.8,2.9l-2.61,4.68,4.32,3.08,3.56-4a12.76,12.76,0,0,0,3.32.78l1.47,5.15,5.23-.87-.3-5.33a12.48,12.48,0,0,0,2.9-1.8l4.68,2.61,3.09-4.32-4-3.56a12.37,12.37,0,0,0,.78-3.32Zm-16.76,6.5a6.33,6.33,0,1,1,5.2-7.29A6.33,6.33,0,0,1,237.6,60.64Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "236.57px 54.4px"
    },
    id: "el1o4n9woksyz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,306.58v-7.9l-7.89-.88a18.34,18.34,0,0,0-1.94-4.7l5-6.24-5.59-5.59-6.21,5a18.71,18.71,0,0,0-4.69-2l-.88-7.93h-7.9l-.88,7.9a18.9,18.9,0,0,0-4.71,1.93l-6.23-5-5.59,5.58,5,6.21a18.84,18.84,0,0,0-2,4.69l-7.93.89v7.9l7.89.88a18.86,18.86,0,0,0,1.94,4.7l-5,6.24,5.59,5.59,6.21-5a18.71,18.71,0,0,0,4.69,2l.88,7.93h7.91l.87-7.9a18.9,18.9,0,0,0,4.71-1.93l6.23,5,5.59-5.59-5-6.2a18.84,18.84,0,0,0,2-4.69ZM367.74,312a9.43,9.43,0,1,1,9.43-9.43A9.44,9.44,0,0,1,367.74,312Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "367.78px 302.56px"
    },
    id: "elnxrqiaps9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,290.72l-.88-5.24-5.32.3a12.52,12.52,0,0,0-1.81-2.9l2.61-4.68-4.32-3.08-3.55,4a12.93,12.93,0,0,0-3.33-.78L407,273.16l-5.23.87.29,5.33a12.48,12.48,0,0,0-2.9,1.8l-4.68-2.61-3.08,4.32,4,3.56a12.76,12.76,0,0,0-.78,3.32l-5.15,1.46.88,5.24,5.32-.3a12.48,12.48,0,0,0,1.8,2.9l-2.61,4.68,4.32,3.08,3.56-4a12.46,12.46,0,0,0,3.32.78l1.47,5.15,5.23-.87-.29-5.33a12.91,12.91,0,0,0,2.9-1.8l4.68,2.61,3.08-4.32-4-3.56a12.37,12.37,0,0,0,.78-3.32Zm-16.77,6.49a6.33,6.33,0,1,1,5.2-7.29A6.33,6.33,0,0,1,408.26,297.21Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "407.235px 290.95px"
    },
    id: "el4pbcskm2aka",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-1--inject-195",
    className: "animable",
    style: {
      transformOrigin: "322.745px 141.458px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.33,156.45V126.89l-29.51-3.28A70.25,70.25,0,0,0,378.58,106l18.64-23.3L381,66.49l6.24-4.67H376.33L353.12,80.38A70.4,70.4,0,0,0,335.58,73l-3.3-29.65H302.73L299.45,72.9a70.6,70.6,0,0,0-17.59,7.23L264.62,66.34l4.85-4.85H258.55l-20.89,20.9,18.56,23.2a70,70,0,0,0-7.35,17.54l-29.65,3.3V156l29.51,3.29A70,70,0,0,0,256,176.85l-18.64,23.31,20.89,20.9h10.92l-4.85-4.85,17.14-13.71A70.78,70.78,0,0,0,299,209.85l3.3,29.64h29.55L335.1,210a70.6,70.6,0,0,0,17.59-7.23L376,221.39h10.92l-3.7-7.23,13.67-13.67-18.56-23.21a70,70,0,0,0,7.35-17.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "317.275px 141.42px"
    },
    id: "el2dpytmgdse4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.82,240H302.27a.5.5,0,0,1-.5-.44l-3.26-29.31a70.91,70.91,0,0,1-17-7.14L265,216.25l4.46,4.45a.53.53,0,0,1,.11.55.5.5,0,0,1-.47.31H258.22a.47.47,0,0,1-.35-.15L237,200.51a.49.49,0,0,1,0-.66l18.42-23a71.09,71.09,0,0,1-7-17.09l-29.17-3.24a.5.5,0,0,1-.45-.5V126.43a.5.5,0,0,1,.45-.5l29.3-3.26a70.84,70.84,0,0,1,7.14-17L237.26,82.7a.52.52,0,0,1,0-.67l20.9-20.89a.47.47,0,0,1,.35-.15h10.92a.5.5,0,0,1,.36.85l-4.46,4.46,16.54,13.23a70.48,70.48,0,0,1,17.08-7l3.24-29.17a.52.52,0,0,1,.5-.45h29.55a.51.51,0,0,1,.5.45L336,72.64a71.28,71.28,0,0,1,17,7.13L376,61.43a.52.52,0,0,1,.32-.11h10.92a.51.51,0,0,1,.47.34.49.49,0,0,1-.18.56l-5.78,4.33,15.82,15.81a.5.5,0,0,1,0,.67l-18.43,23a70.65,70.65,0,0,1,7,17.08l29.17,3.25a.5.5,0,0,1,.45.49v29.56a.49.49,0,0,1-.45.49l-29.3,3.26a70.91,70.91,0,0,1-7.14,17l18.34,22.94a.49.49,0,0,1,0,.66l-13.42,13.42,3.53,6.9a.5.5,0,0,1,0,.49.49.49,0,0,1-.42.24H376a.52.52,0,0,1-.32-.11l-23-18.43a71,71,0,0,1-17.08,7l-3.24,29.17A.51.51,0,0,1,331.82,240Zm-29.11-1h28.66l3.23-29.06a.5.5,0,0,1,.38-.43,70.15,70.15,0,0,0,17.46-7.19.52.52,0,0,1,.56,0l23.17,18.54h9.93l-3.33-6.5a.5.5,0,0,1,.1-.58l13.35-13.36L377.94,177.6a.52.52,0,0,1,0-.57,69.8,69.8,0,0,0,7.3-17.41.49.49,0,0,1,.42-.37L414.83,156V127.34l-29.07-3.23a.51.51,0,0,1-.43-.37,69.81,69.81,0,0,0-7.18-17.47.48.48,0,0,1,0-.56l18.36-23-15.9-15.9a.5.5,0,0,1,.05-.76l5-3.77H376.5L353.43,80.77a.5.5,0,0,1-.56,0,70,70,0,0,0-17.42-7.29.53.53,0,0,1-.37-.43l-3.24-29.21H303.18L300,73a.51.51,0,0,1-.38.43,70.12,70.12,0,0,0-17.46,7.18.48.48,0,0,1-.56,0L264.31,66.73a.49.49,0,0,1,0-.74l4-4h-9.51L238.33,82.43l18.28,22.85a.51.51,0,0,1,0,.57,69.8,69.8,0,0,0-7.3,17.41.49.49,0,0,1-.43.37l-29.2,3.25v28.66l29.07,3.23a.51.51,0,0,1,.43.37,69.74,69.74,0,0,0,7.18,17.46.52.52,0,0,1,0,.57l-18.36,23,20.43,20.44h9.51l-4-4a.5.5,0,0,1-.15-.38.54.54,0,0,1,.19-.37l17.14-13.7a.48.48,0,0,1,.56,0,70,70,0,0,0,17.42,7.29.52.52,0,0,1,.37.43Zm112.62-82.54h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "317.28px 141.456px"
    },
    id: "els8xp2ulvasd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.25,156.45V126.89l-29.51-3.28A70.25,70.25,0,0,0,389.5,106l18.64-23.3-20.9-20.9L364,80.38A70.4,70.4,0,0,0,346.5,73l-3.3-29.65H313.65L310.37,72.9a70.6,70.6,0,0,0-17.59,7.23L269.47,61.49l-20.89,20.9,18.56,23.2a70,70,0,0,0-7.35,17.54l-29.65,3.3V156l29.51,3.29a70,70,0,0,0,7.24,17.58l-18.64,23.31,20.89,20.9,23.21-18.56a70.78,70.78,0,0,0,17.54,7.35l3.3,29.64h29.55L346,210a70.6,70.6,0,0,0,17.59-7.23l23.31,18.64,20.89-20.9-18.56-23.21a70,70,0,0,0,7.35-17.53Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "328.195px 141.43px"
    },
    id: "els48380h3dyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.74,240H313.19a.5.5,0,0,1-.5-.44l-3.26-29.31a70.91,70.91,0,0,1-17-7.14l-22.93,18.35a.5.5,0,0,1-.67,0l-20.9-20.9a.49.49,0,0,1,0-.66l18.42-23a71.09,71.09,0,0,1-7-17.09l-29.18-3.24a.5.5,0,0,1-.44-.5V126.43a.5.5,0,0,1,.44-.5l29.31-3.26a70.84,70.84,0,0,1,7.14-17L248.18,82.7a.52.52,0,0,1,0-.67l20.9-20.89a.49.49,0,0,1,.66,0l23.05,18.43a70.65,70.65,0,0,1,17.08-7l3.24-29.17a.52.52,0,0,1,.5-.45H343.2a.51.51,0,0,1,.5.45L347,72.64a71.28,71.28,0,0,1,17,7.13l22.93-18.34a.5.5,0,0,1,.67,0l20.9,20.89a.5.5,0,0,1,0,.67l-18.43,23a70.65,70.65,0,0,1,7,17.08l29.17,3.25a.5.5,0,0,1,.45.49v29.56a.49.49,0,0,1-.45.49L397,160.2a71.28,71.28,0,0,1-7.13,17l18.34,22.94a.49.49,0,0,1,0,.66l-20.9,20.9a.5.5,0,0,1-.67,0l-23-18.43a71,71,0,0,1-17.08,7l-3.24,29.17A.51.51,0,0,1,342.74,240Zm-29.11-1h28.66l3.23-29.06a.5.5,0,0,1,.38-.43,70.31,70.31,0,0,0,17.46-7.19.52.52,0,0,1,.56,0l23,18.37,20.26-20.27L388.86,177.6a.52.52,0,0,1,0-.57,69.8,69.8,0,0,0,7.3-17.41.49.49,0,0,1,.42-.37L425.75,156V127.34l-29.07-3.23a.51.51,0,0,1-.43-.37,69.81,69.81,0,0,0-7.18-17.47.48.48,0,0,1,0-.56l18.36-23L387.21,62.49,364.35,80.77a.5.5,0,0,1-.56,0,70,70,0,0,0-17.42-7.29.53.53,0,0,1-.37-.43l-3.24-29.21H314.1L310.86,73a.49.49,0,0,1-.37.43A70.12,70.12,0,0,0,293,80.56a.48.48,0,0,1-.56,0l-23-18.36L249.25,82.43l18.28,22.85a.51.51,0,0,1,0,.57,69.8,69.8,0,0,0-7.3,17.41.49.49,0,0,1-.43.37l-29.2,3.25v28.66l29.07,3.23a.51.51,0,0,1,.43.37,69.74,69.74,0,0,0,7.18,17.46.52.52,0,0,1,0,.57l-18.36,23,20.26,20.27L292,202.11a.48.48,0,0,1,.56,0A69.84,69.84,0,0,0,310,209.36a.49.49,0,0,1,.36.43Zm112.62-82.54h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.21px 141.478px"
    },
    id: "el6e3irmiepqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.9,
    cy: 144.29,
    r: 59.28,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.9px 144.29px"
    },
    id: "el3p2oi8uzg5f",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-195",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "300.746px 390.525px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.16,363.68c2.59,1.13,8.93,1,8.93,1s-1.36-4.15-1.48-4.4c-1.39-2.91-5.79-7.71-9.36-7.23a4.27,4.27,0,0,0-3.43,5.35C255.41,360.87,258,362.71,260.16,363.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "261.878px 358.851px"
    },
    id: "el738w3tajpxj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.35,382c2.69.39,8.34-1.25,8.79-1.38a75.7,75.7,0,0,0,3.43,9.49c.78,1.8,1.62,3.59,2.48,5.37-.51-.75-1-1.42-1.06-1.51-2.11-2.44-7.61-5.91-10.94-4.5a4.28,4.28,0,0,0-1.89,6.07c1.23,2.24,4.17,3.34,6.55,3.69s7.27-.95,8.54-1.31l1,2c1.64,3.26,3.29,6.51,4.81,9.74.54,1.14,1,2.28,1.51,3.42-.46-.67-.85-1.23-.92-1.31-2.11-2.44-7.62-5.91-10.94-4.5a4.28,4.28,0,0,0-1.89,6.07c1.23,2.24,4.16,3.34,6.55,3.69s6.79-.83,8.31-1.25c.47,1.18.94,2.37,1.34,3.54.25.8.55,1.56.76,2.38s.45,1.61.67,2.4c.37,1.54.77,3.13,1.09,4.64.23,1.05.43,2.06.64,3.07-.52-1.14-1.59-3.35-1.7-3.52-1.71-2.73-6.63-7-10.13-6.11a4.28,4.28,0,0,0-2.79,5.72c.88,2.39,3.61,3.93,5.92,4.63,2.53.78,8.14.07,8.84,0,.34,1.68.65,3.32.92,4.86.6,3.42,1.06,6.48,1.4,9.07H296c-.41-2.68-.95-5.88-1.67-9.46-.33-1.7-.72-3.52-1.14-5.38a46.09,46.09,0,0,0,4.93-2.32c1.85,2,6.59,4.34,7.2,4.64-.65,1.59-1.29,3.12-1.92,4.56-1.31,3-2.55,5.68-3.65,8h2.56c.95-2.1,2-4.48,3.06-7.13.66-1.6,1.34-3.33,2-5.12.68.15,6.24,1.27,8.83.69,2.35-.53,5.19-1.86,6.24-4.18a4.28,4.28,0,0,0-2.36-5.91c-3.42-1.15-8.64,2.74-10.55,5.33-.12.16-1.16,1.95-1.79,3.1.27-.73.54-1.44.81-2.19.55-1.49,1.05-3,1.59-4.6l.72-2.39c.26-.8.42-1.67.64-2.5.47-2,.84-4,1.18-6,1.3.48,6,2.1,8.37,1.93s5.42-1.05,6.81-3.19a4.27,4.27,0,0,0-1.44-6.19c-3.21-1.66-9,1.4-11.24,3.67-.14.14-1.6,2-2.38,3,.19-1.22.39-2.44.54-3.68.45-3.58.78-7.21,1.14-10.84.1-1.11.23-2.21.34-3.32.47.17,6,2.22,8.66,2,2.4-.17,5.42-1.05,6.81-3.19a4.27,4.27,0,0,0-1.44-6.19c-3.21-1.66-9,1.39-11.24,3.67-.18.17-2.27,2.78-2.77,3.48.26-2.44.54-4.87.91-7.25a75.3,75.3,0,0,1,2.08-9.54c.22.09,5.94,2.25,8.71,2,2.4-.17,5.42-1,6.81-3.18a4.28,4.28,0,0,0-1.44-6.2c-3.21-1.65-9,1.4-11.24,3.67-.18.18-2.43,3-2.8,3.54.05-.19.09-.38.14-.56a54.86,54.86,0,0,1,3.78-9c.82-1.61,1.69-3.1,2.58-4.53,1,.52,5.73,2.8,8.24,2.9s5.5-.45,7.12-2.42a4.27,4.27,0,0,0-.75-6.31c-3-2-9.06.4-11.58,2.41-.14.11-1.41,1.38-2.32,2.31.41-.64.82-1.31,1.22-1.91,1.51-2.27,3-4.26,4.4-6,.78-1,1.51-1.86,2.2-2.68,1.27,0,6.37-.18,8.61-1.22s4.67-2.94,5.19-5.43a4.27,4.27,0,0,0-3.57-5.26c-3.59-.39-7.85,4.53-9.16,7.48-.12.25-1.43,4.44-1.36,4.43h.07c-.68.78-1.4,1.61-2.16,2.54-1.41,1.72-3,3.68-4.54,5.93a75.91,75.91,0,0,0-4.71,7.5,56.18,56.18,0,0,0-4,9.05.56.56,0,0,1,0,.12c0-1.06,0-4-.05-4.24-.42-3.2-3.1-9.13-6.65-9.79a4.27,4.27,0,0,0-4.92,4c-.21,2.54,1.63,5.08,3.43,6.68,2,1.81,7.64,3.56,8.09,3.7a74.71,74.71,0,0,0-2.37,9.81c-.35,1.93-.64,3.89-.9,5.85,0-.91,0-1.73-.05-1.85-.41-3.19-3.09-9.13-6.64-9.78a4.27,4.27,0,0,0-4.93,4c-.21,2.54,1.64,5.08,3.43,6.68s6.59,3.22,7.85,3.62c-.09.76-.19,1.51-.28,2.27-.44,3.62-.85,7.23-1.37,10.77-.18,1.25-.4,2.47-.63,3.69,0-.81,0-1.5,0-1.6-.41-3.2-3.09-9.13-6.64-9.79a4.27,4.27,0,0,0-4.93,4c-.21,2.54,1.63,5.08,3.43,6.68s6.12,3.06,7.62,3.55c-.26,1.25-.52,2.49-.83,3.69-.23.81-.4,1.6-.68,2.41s-.51,1.59-.76,2.37c-.55,1.49-1.1,3-1.66,4.47-.39,1-.77,2-1.16,2.91.2-1.23.53-3.67.53-3.87a16.62,16.62,0,0,0-2.22-8.07,5.06,5.06,0,0,0-.06-.95,4.28,4.28,0,0,0-5.23-3.62c-3.48.93-5.7,7.05-5.86,10.27,0,.19.11,2.26.21,3.57-.17-.76-.33-1.5-.52-2.28-.37-1.54-.78-3.07-1.22-4.72-.23-.78-.48-1.58-.72-2.38s-.56-1.62-.84-2.44c-.69-1.89-1.48-3.77-2.32-5.64,1.35-.32,6.13-1.54,8-3s3.93-3.87,3.91-6.42a4.26,4.26,0,0,0-4.61-4.37c-3.59.39-6.7,6.11-7.35,9.26-.05.2-.26,2.52-.35,3.79-.51-1.12-1-2.24-1.58-3.36-1.6-3.23-3.32-6.45-5-9.67-.52-1-1-2-1.55-3,.49-.11,6.2-1.44,8.35-3.09,1.91-1.46,3.93-3.86,3.91-6.41a4.26,4.26,0,0,0-4.61-4.37c-3.59.39-6.7,6.1-7.35,9.26-.05.24-.35,3.57-.39,4.43-1.13-2.18-2.24-4.36-3.24-6.55a75,75,0,0,1-3.52-9.1c.22-.05,6.19-1.41,8.39-3.1,1.91-1.46,3.94-3.86,3.92-6.41a4.28,4.28,0,0,0-4.62-4.37c-3.59.39-6.7,6.11-7.35,9.26-.05.25-.37,3.84-.39,4.49-.05-.18-.13-.36-.18-.54a55.17,55.17,0,0,1-1.83-9.61c-.2-1.79-.29-3.51-.34-5.19,1.13-.14,6.32-.83,8.47-2.13s4.34-3.41,4.6-5.95a4.26,4.26,0,0,0-4.1-4.85c-3.61,0-7.34,5.33-8.33,8.4-.06.17-.42,1.92-.66,3.21,0-.76,0-1.55,0-2.27,0-2.73.18-5.23.35-7.44.11-1.26.23-2.4.35-3.46,1-.72,5.22-3.66,6.51-5.77s2.28-5,1.34-7.39a4.28,4.28,0,0,0-5.88-2.42c-3.21,1.66-4.05,8.12-3.52,11.29.05.28,1.26,4.49,1.31,4.46l.07-.05c-.15,1-.29,2.12-.41,3.31-.22,2.22-.45,4.72-.51,7.46a72.46,72.46,0,0,0,.21,8.85,55.55,55.55,0,0,0,1.64,9.77l0,.11c-.57-.89-2.24-3.33-2.39-3.51-2.11-2.43-7.61-5.9-10.94-4.49a4.27,4.27,0,0,0-1.89,6.07C257,380.58,260,381.68,262.35,382Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.042px 390.525px"
    },
    id: "ell00m1f8jxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.25,365.07c.06,0,1.15-4.21,1.19-4.49.45-3.19-.57-9.62-3.82-11.19a4.27,4.27,0,0,0-5.81,2.58c-.88,2.39.23,5.33,1.54,7.35C318.88,361.69,324.25,365.07,324.25,365.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.518px 357.043px"
    },
    id: "elyxhp6oqfrwo",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrows-2--inject-195",
    className: "animable animator-active",
    style: {
      transformOrigin: "497.725px 151.165px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "553.74 156.48 550.74 156.48 550.74 135.15 434.22 135.15 434.22 132.15 553.74 132.15 553.74 156.48",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "493.98px 144.315px"
    },
    id: "elnpzb8q6v19f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.37 153.81 552.24 169.62 543.12 153.81 561.37 153.81",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "552.245px 161.715px"
    },
    id: "el9yubqwq36s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "535.32 170.18 532.32 170.18 532.32 149.76 447.22 149.76 447.22 146.76 535.32 146.76 535.32 170.18",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "491.27px 158.47px"
    },
    id: "el7w24s97z7rg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.89 139.13 434.08 148.26 449.89 157.38 449.89 139.13",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "441.985px 148.255px"
    },
    id: "elb15r6eedz3",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrows-1--inject-195",
    className: "animable",
    style: {
      transformOrigin: "156.72px 152.34px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "109.74 157.83 106.74 157.83 106.74 132.15 214.33 132.15 214.33 135.15 109.74 135.15 109.74 157.83",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "160.535px 144.99px"
    },
    id: "elabe9j2mqezw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.36 155.16 108.24 170.97 99.11 155.16 117.36 155.16",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.235px 163.065px"
    },
    id: "el7wxujyzsz1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.16 172.53 125.16 172.53 125.16 146.76 199.63 146.76 199.63 149.76 128.16 149.76 128.16 172.53",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.395px 159.645px"
    },
    id: "eldeeg6c3qv9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.96 157.38 212.76 148.26 196.96 139.13 196.96 157.38",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.86px 148.255px"
    },
    id: "elv15yxtt6et",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-195",
    className: "animable",
    style: {
      transformOrigin: "574.24px 311.89px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.88,383.74l-30.12,48.52a9.29,9.29,0,0,0,7.89,14.18h61.52a9.28,9.28,0,0,1-7.91-14.14l29.15-47.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "518.39px 415.09px"
    },
    id: "elpwglngl8j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.54,446.94H481.65A9.78,9.78,0,0,1,473.34,432l30.11-48.52a.5.5,0,0,1,.44-.24l60.53,1.09a.5.5,0,0,1,.43.25.52.52,0,0,1,0,.51l-29.15,47.47a8.78,8.78,0,0,0,7.48,13.38h76.37a.5.5,0,0,1,.5.5A.5.5,0,0,1,619.54,446.94ZM504.15,384.25l-30,48.28a8.78,8.78,0,0,0,7.46,13.41h57.17a9.81,9.81,0,0,1-4.19-4,9.66,9.66,0,0,1,.2-9.89l28.7-46.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "545.959px 415.09px"
    },
    id: "el94nxnath1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.83,383.74l-30.12,48.52c-3.84,6.18.61,12.71,7.89,12.71h61.52c-7.26,0-11.71-6.49-7.91-12.67l29.15-47.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "522.329px 414.355px"
    },
    id: "el3optz2q92zh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.68,445.47H485.6a9.77,9.77,0,0,1-8.8-4.7,8.46,8.46,0,0,1,.49-8.77l30.11-48.52a.51.51,0,0,1,.43-.24l60.54,1.09a.5.5,0,0,1,.43.25.52.52,0,0,1,0,.51l-29.15,47.47a7.5,7.5,0,0,0-.43,7.74,8.8,8.8,0,0,0,7.92,4.17h72.56a.5.5,0,0,1,.5.5A.5.5,0,0,1,619.68,445.47ZM508.1,384.25l-30,48.28a7.48,7.48,0,0,0-.46,7.75,8.78,8.78,0,0,0,7.92,4.19h56.78a8.83,8.83,0,0,1-4-3.68,8.47,8.47,0,0,1,.45-8.75l28.69-46.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "548.002px 414.36px"
    },
    id: "el8ezorltalke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.89,
    y: 444.97,
    width: 82.79,
    height: 1.39,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "578.285px 445.665px"
    },
    id: "elxkpqrwggtve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.68,446.86H536.89a.5.5,0,0,1-.5-.5V445a.5.5,0,0,1,.5-.5h82.79a.5.5,0,0,1,.5.5v1.39A.5.5,0,0,1,619.68,446.86Zm-82.29-1h81.79v-.39H537.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "578.285px 445.68px"
    },
    id: "elpw22aslkxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.82 383.74 568.36 384.82 557.15 403.08 495.82 403.08 507.82 383.74",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "532.09px 393.41px"
    },
    id: "elq28yg9vjpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.15,403.58H495.82a.48.48,0,0,1-.43-.26.47.47,0,0,1,0-.5l12-19.34a.51.51,0,0,1,.43-.24l60.54,1.09a.5.5,0,0,1,.43.25.52.52,0,0,1,0,.51l-11.21,18.25A.49.49,0,0,1,557.15,403.58Zm-60.43-1h60.15l10.6-17.27-59.37-1.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "532.087px 393.41px"
    },
    id: "el2ftml3bnqeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.03,
    y: 177.28,
    width: 257.26,
    height: 217.27,
    rx: 2.91,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "545.66px 285.915px"
    },
    id: "elmxd6o472am",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.38,395.05H419.94a3.41,3.41,0,0,1-3.41-3.41V180.2a3.42,3.42,0,0,1,3.41-3.42H671.38a3.42,3.42,0,0,1,3.41,3.42V391.64A3.41,3.41,0,0,1,671.38,395.05ZM419.94,177.78a2.42,2.42,0,0,0-2.41,2.42V391.64a2.41,2.41,0,0,0,2.41,2.41H671.38a2.41,2.41,0,0,0,2.41-2.41V180.2a2.42,2.42,0,0,0-2.41-2.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "545.66px 285.915px"
    },
    id: "elg2lkayup98s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.75,
    y: 177.28,
    width: 257.26,
    height: 217.27,
    rx: 2.91,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "555.38px 285.915px"
    },
    id: "el3jjg6ou1ve2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.11,395.05H429.67a3.42,3.42,0,0,1-3.42-3.41V180.2a3.42,3.42,0,0,1,3.42-3.42H681.11a3.42,3.42,0,0,1,3.41,3.42V391.64A3.41,3.41,0,0,1,681.11,395.05ZM429.67,177.78a2.43,2.43,0,0,0-2.42,2.42V391.64a2.42,2.42,0,0,0,2.42,2.41H681.11a2.41,2.41,0,0,0,2.41-2.41V180.2a2.42,2.42,0,0,0-2.41-2.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "555.385px 285.915px"
    },
    id: "elszrktxut92",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.15,177.28H428.62a1.87,1.87,0,0,0-1.87,1.87V355.64H684V179.15A1.87,1.87,0,0,0,682.15,177.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "555.375px 266.46px"
    },
    id: "el9ltketujiau",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684,356.14H426.75a.5.5,0,0,1-.5-.5V179.15a2.38,2.38,0,0,1,2.37-2.37H682.15a2.38,2.38,0,0,1,2.37,2.37V355.64A.5.5,0,0,1,684,356.14Zm-256.77-1H683.52v-176a1.37,1.37,0,0,0-1.37-1.37H428.62a1.38,1.38,0,0,0-1.37,1.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "555.385px 266.46px"
    },
    id: "elokcvx47ewz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.56,
    y: 185.93,
    width: 235.65,
    height: 157.82,
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "555.385px 264.84px"
    },
    id: "el7mnu1xqs46r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.21,344.25H437.56a.5.5,0,0,1-.5-.5V185.93a.51.51,0,0,1,.5-.5H673.21a.5.5,0,0,1,.5.5V343.75A.5.5,0,0,1,673.21,344.25Zm-235.15-1H672.71V186.43H438.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "555.385px 264.84px"
    },
    id: "elzkmcsqh387i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.56,
    y: 185.93,
    width: 235.65,
    height: 16.87,
    style: {
      fill: "#477BF0",
      transformOrigin: "555.385px 194.365px"
    },
    id: "el2drjc2vemsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.21,203.31H437.56a.51.51,0,0,1-.5-.5V185.93a.51.51,0,0,1,.5-.5H673.21a.5.5,0,0,1,.5.5v16.88A.5.5,0,0,1,673.21,203.31Zm-235.15-1H672.71V186.43H438.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "555.385px 194.37px"
    },
    id: "elecz5zjyaw77",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elahlf6shtx"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 720.11,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "723.85px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elwrt64avp0zh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M727.59,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,727.59,438.57Zm-7-1h6.48v-1.5h-6.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "723.85px 436.82px"
    },
    id: "el2mm3jqo7ssu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljrlq4xucg2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 710.13,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "713.87px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "els49oezyq9q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M717.61,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,717.61,438.57Zm-7-1h6.48v-1.5h-6.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "713.87px 436.82px"
    },
    id: "elwn436t9ygdp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc896ec07ljv"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 700.15,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "703.89px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elxl5oerpx8ea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M707.63,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,707.63,438.57Zm-7-1h6.48v-1.5h-6.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "703.89px 436.82px"
    },
    id: "el0lkcj575s7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elftkgdpfc2tf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 690.17,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "693.91px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elroupiiarshi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M697.66,438.57h-7.49a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.49a.51.51,0,0,1,.5.5v2.5A.5.5,0,0,1,697.66,438.57Zm-7-1h6.49v-1.5h-6.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "693.915px 436.82px"
    },
    id: "eln0yn33hglh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elai7aqzj7slm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 680.19,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "683.93px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el4kg3zhel305"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M687.68,438.57h-7.49a.5.5,0,0,1-.5-.5v-2.5a.51.51,0,0,1,.5-.5h7.49a.51.51,0,0,1,.5.5v2.5A.5.5,0,0,1,687.68,438.57Zm-7-1h6.49v-1.5h-6.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "683.935px 436.82px"
    },
    id: "elelinocrc6ge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmwgngagqc8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 670.21,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "673.95px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el7fj4fxt28ya"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M677.7,438.57h-7.49a.5.5,0,0,1-.5-.5v-2.5a.51.51,0,0,1,.5-.5h7.49a.51.51,0,0,1,.5.5v2.5A.5.5,0,0,1,677.7,438.57Zm-7-1h6.49v-1.5h-6.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "673.955px 436.82px"
    },
    id: "elqidnxskhjhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell5989864zh7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.23,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "663.97px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elky6m6bnm3mc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M667.72,438.57h-7.49a.5.5,0,0,1-.5-.5v-2.5a.51.51,0,0,1,.5-.5h7.49a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,667.72,438.57Zm-7-1h6.49v-1.5h-6.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "663.975px 436.82px"
    },
    id: "ely97dkw6o53m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elryzf9iwu7v"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.26,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "654px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elr95q2bkdgk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M657.74,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,657.74,438.57Zm-7-1h6.48v-1.5h-6.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "654px 436.82px"
    },
    id: "elqawcmbf4ok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgp5iqce8lpg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.28,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "644.02px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el7kd9sz0jrbw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M647.76,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,647.76,438.57Zm-7-1h6.48v-1.5h-6.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "644.02px 436.82px"
    },
    id: "elg58vko4bxz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfc0qsbgy0d7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.3,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "634.04px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el76jwotygxda"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.78,438.57H630.3a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,637.78,438.57Zm-7-1h6.48v-1.5H630.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "634.04px 436.82px"
    },
    id: "elj83os87mudn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloq7tppigmdp"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.32,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "624.06px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elh2ch3v6rfwg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M627.8,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,627.8,438.57Zm-7-1h6.48v-1.5h-6.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "624.06px 436.82px"
    },
    id: "elbxqjndw71s7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elftrq5papkc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.34,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "614.08px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elr4mtojubxxo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M617.82,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,617.82,438.57Zm-7-1h6.48v-1.5h-6.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "614.08px 436.82px"
    },
    id: "elwxpojvkoqnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8zawpkphocl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.36,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "604.1px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elvukhueo65w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M607.85,438.57h-7.49a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.49a.51.51,0,0,1,.5.5v2.5A.5.5,0,0,1,607.85,438.57Zm-7-1h6.49v-1.5h-6.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "604.105px 436.82px"
    },
    id: "el6b6ua8yhhx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv90j0xsorq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590.38,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "594.12px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elr5i3f5rvxtk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M597.87,438.57h-7.49a.5.5,0,0,1-.5-.5v-2.5a.51.51,0,0,1,.5-.5h7.49a.51.51,0,0,1,.5.5v2.5A.5.5,0,0,1,597.87,438.57Zm-7-1h6.49v-1.5h-6.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "594.125px 436.82px"
    },
    id: "elmptvb5rxe9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv0ixs9v8zv"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.4,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "584.14px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eltpc22c8d7p"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M587.89,438.57H580.4a.5.5,0,0,1-.5-.5v-2.5a.51.51,0,0,1,.5-.5h7.49a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,587.89,438.57Zm-7-1h6.49v-1.5H580.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "584.145px 436.82px"
    },
    id: "ela5absi1s3iu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnaokd3x2opn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.43,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "574.17px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elecly17mczlu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M577.91,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,577.91,438.57Zm-7-1h6.48v-1.5h-6.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "574.17px 436.82px"
    },
    id: "elzfqp06nlhg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfkueu9kyrnd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.45,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "564.19px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elypqufwncg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M567.93,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h7.48a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,567.93,438.57Zm-7-1h6.48v-1.5H561Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "564.19px 436.82px"
    },
    id: "elc5933hkxx7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el24li0a78a9z"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.47,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "554.21px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "ellgbwy0970ds"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5H558a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,558,438.57Zm-7-1h6.48v-1.5H551Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "554.26px 436.82px"
    },
    id: "elsrm7ia2m1bq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8hb32s4zps"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.49,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "544.23px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elpw7x0prjsgr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M548,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5H548a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,548,438.57Zm-7-1h6.48v-1.5H541Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "544.26px 436.82px"
    },
    id: "elr1tdoxl5gh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el020qy8lmvptn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.51,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "534.25px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "ela4s2ovb5oei"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M538,438.57h-7.48a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5H538a.5.5,0,0,1,.5.5v2.5A.5.5,0,0,1,538,438.57Zm-7-1h6.48v-1.5H531Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "534.26px 436.82px"
    },
    id: "eldhhsl30piym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elebuohbzagt"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.53,
    y: 435.57,
    width: 7.48,
    height: 2.49,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "524.27px 436.815px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elwdt1idbdp6f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528,438.57h-7.49a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5H528a.51.51,0,0,1,.5.5v2.5A.5.5,0,0,1,528,438.57Zm-7-1h6.49v-1.5H521Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "524.255px 436.82px"
    },
    id: "elimj3a5fukhb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk3scv922h1b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.08,
    y: 438.43,
    width: 216.37,
    height: 8.07,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "623.265px 442.465px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elznpdoyukem"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M731.45,447H515.08a.51.51,0,0,1-.5-.5v-8.07a.5.5,0,0,1,.5-.5H731.45a.5.5,0,0,1,.5.5v8.07A.5.5,0,0,1,731.45,447Zm-215.87-1H731v-7.07H515.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "623.265px 442.465px"
    },
    id: "el6joqqlos8ng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli8lnlkyct9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.08,
    y: 438.43,
    width: 52.78,
    height: 8.07,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "541.47px 442.465px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elu1ozaxyjda"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M567.86,447H515.08a.51.51,0,0,1-.5-.5v-8.07a.5.5,0,0,1,.5-.5h52.78a.5.5,0,0,1,.5.5v8.07A.5.5,0,0,1,567.86,447Zm-52.28-1h51.78v-7.07H515.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "541.47px 442.465px"
    },
    id: "elkhjkjcdfx1",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-195",
    className: "animable",
    style: {
      transformOrigin: "556.905px 274.925px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elhh8g1yvydpd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.05,
    y: 232.92,
    width: 150.52,
    height: 86.82,
    style: {
      opacity: 0.3,
      transformOrigin: "558.31px 276.33px"
    },
    className: "animable",
    id: "elyf950wnm5gd"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 480.74,
    y: 230.61,
    width: 150.52,
    height: 86.82,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "556px 274.02px"
    },
    id: "elik07bu4ep4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.76,317.92H480.24V230.11H631.76Zm-150.52-1H630.76V231.11H481.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "556px 274.015px"
    },
    id: "eldnv7p738w0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.81,279.79l-1.58-.11a10.44,10.44,0,0,0-.15-1.59l1.53-.41a.45.45,0,0,0,.32-.55l-.2-.71a.44.44,0,0,0-.55-.32l-1.52.41a9.64,9.64,0,0,0-.67-1.46l1.31-.88a.45.45,0,0,0,.13-.62l-.42-.62a.45.45,0,0,0-.62-.12l-1.31.89a10.1,10.1,0,0,0-1.1-1.16l.95-1.26a.46.46,0,0,0-.09-.64l-.59-.44a.45.45,0,0,0-.63.09l-1,1.26a10,10,0,0,0-1.42-.74l.49-1.5a.45.45,0,0,0-.29-.57l-.7-.22a.45.45,0,0,0-.57.28l-.49,1.51a9.21,9.21,0,0,0-1.41-.22V268.5a.45.45,0,0,0-.45-.45h-.73a.45.45,0,0,0-.45.45v1.59a9.14,9.14,0,0,0-1.58.26l-.51-1.5a.47.47,0,0,0-.58-.28l-.69.24a.46.46,0,0,0-.28.58l.51,1.49a9.92,9.92,0,0,0-1.4.76l-1-1.24a.45.45,0,0,0-.63-.08l-.58.45a.47.47,0,0,0-.08.64l1,1.24a11,11,0,0,0-1.08,1.18l-1.33-.86a.44.44,0,0,0-.62.13l-.4.62a.44.44,0,0,0,.13.62l1.32.86a9.57,9.57,0,0,0-.63,1.47l-1.54-.38a.44.44,0,0,0-.54.32l-.18.72a.46.46,0,0,0,.33.55l1.53.38a10.05,10.05,0,0,0-.12,1.56v0l-1.58.14a.45.45,0,0,0-.41.49l.07.73a.45.45,0,0,0,.48.41l1.58-.14a10.07,10.07,0,0,0,.4,1.55l-1.44.64a.45.45,0,0,0-.23.6l.3.67a.44.44,0,0,0,.59.23l1.44-.64a9.94,9.94,0,0,0,.89,1.33l-1.16,1.08a.44.44,0,0,0,0,.63l.5.54a.46.46,0,0,0,.64,0l1.15-1.07a10.92,10.92,0,0,0,1.27,1l-.74,1.39a.45.45,0,0,0,.19.61l.65.35a.45.45,0,0,0,.61-.19l.74-1.39a9.57,9.57,0,0,0,1.51.51l-.24,1.56a.44.44,0,0,0,.37.51l.73.12a.44.44,0,0,0,.51-.38l.25-1.56c.24,0,.47,0,.72,0s.59,0,.88,0l.27,1.55a.46.46,0,0,0,.53.37l.72-.13a.45.45,0,0,0,.37-.52l-.28-1.56a8.71,8.71,0,0,0,1.51-.53l.76,1.38a.46.46,0,0,0,.62.18l.64-.36a.45.45,0,0,0,.18-.61l-.77-1.38a11,11,0,0,0,1.25-1l1.18,1.06a.44.44,0,0,0,.63,0l.5-.55a.46.46,0,0,0,0-.64l-1.17-1.06a9.85,9.85,0,0,0,.86-1.34l1.45.61a.45.45,0,0,0,.59-.23l.29-.68a.44.44,0,0,0-.24-.59l-1.45-.62a10,10,0,0,0,.37-1.55l1.58.11a.46.46,0,0,0,.48-.42l.05-.74A.45.45,0,0,0,557.81,279.79Zm-11.34,5.51a5.48,5.48,0,1,1,5.48-5.48A5.48,5.48,0,0,1,546.47,285.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "546.451px 279.768px"
    },
    id: "elxa7v2x7zt3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.46,288a8.16,8.16,0,1,1,8.17-8.16A8.17,8.17,0,0,1,546.46,288Zm0-15.32a7.16,7.16,0,1,0,7.17,7.16A7.17,7.17,0,0,0,546.46,272.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "546.47px 279.84px"
    },
    id: "el4wqi9zpwp9w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,287.74l-1-.07a7.18,7.18,0,0,0-.1-1l1-.27a.29.29,0,0,0,.21-.36l-.13-.47a.3.3,0,0,0-.36-.21l-1,.27a6.27,6.27,0,0,0-.43-.95l.86-.58a.3.3,0,0,0,.08-.41l-.27-.4a.3.3,0,0,0-.41-.08l-.86.58a6.47,6.47,0,0,0-.72-.76l.62-.83a.29.29,0,0,0-.06-.41l-.38-.29a.3.3,0,0,0-.42.06l-.62.83a6.89,6.89,0,0,0-.93-.49l.32-1a.3.3,0,0,0-.19-.38l-.46-.15a.3.3,0,0,0-.37.19l-.32,1a7.06,7.06,0,0,0-.92-.15v-1a.3.3,0,0,0-.3-.3h-.48a.29.29,0,0,0-.3.3v1a6.92,6.92,0,0,0-1,.17l-.34-1a.29.29,0,0,0-.37-.19l-.46.16a.29.29,0,0,0-.18.38l.33,1a5.88,5.88,0,0,0-.92.5l-.63-.82a.3.3,0,0,0-.42,0l-.38.3a.29.29,0,0,0-.05.41l.64.82a5.79,5.79,0,0,0-.71.77l-.87-.57a.29.29,0,0,0-.41.09l-.26.41a.28.28,0,0,0,.09.4l.86.57a6.3,6.3,0,0,0-.41,1l-1-.25a.29.29,0,0,0-.36.21l-.11.47a.29.29,0,0,0,.21.36l1,.25a5.7,5.7,0,0,0-.08,1v0l-1,.09a.29.29,0,0,0-.26.32l0,.49a.29.29,0,0,0,.32.26l1-.09a6.93,6.93,0,0,0,.26,1l-.94.42a.29.29,0,0,0-.15.39l.19.44a.29.29,0,0,0,.39.15l1-.42a5.72,5.72,0,0,0,.58.87l-.76.71a.29.29,0,0,0,0,.41l.33.36a.3.3,0,0,0,.42,0l.76-.7a7.25,7.25,0,0,0,.83.63l-.49.92a.3.3,0,0,0,.13.4l.42.22a.29.29,0,0,0,.4-.12l.49-.91a5.75,5.75,0,0,0,1,.33l-.16,1a.29.29,0,0,0,.24.34l.48.08a.31.31,0,0,0,.34-.25l.16-1,.47,0a5.63,5.63,0,0,0,.58,0l.18,1a.29.29,0,0,0,.34.24l.48-.09a.28.28,0,0,0,.23-.34l-.17-1a5.43,5.43,0,0,0,1-.35l.5.91a.3.3,0,0,0,.41.11l.42-.23a.29.29,0,0,0,.11-.4l-.5-.91a6.32,6.32,0,0,0,.82-.65l.77.69a.3.3,0,0,0,.42,0l.32-.36a.29.29,0,0,0,0-.41l-.77-.7a5.71,5.71,0,0,0,.56-.88l.95.4a.29.29,0,0,0,.39-.15l.19-.45a.29.29,0,0,0-.16-.38l-1-.41a6.9,6.9,0,0,0,.25-1l1,.08a.3.3,0,0,0,.31-.28l0-.48A.31.31,0,0,0,572,287.74Zm-7.43,3.62a3.6,3.6,0,1,1,3.59-3.6A3.59,3.59,0,0,1,564.55,291.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "564.648px 287.776px"
    },
    id: "el8e3v6vnf582",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.55,293.28a5.52,5.52,0,1,1,5.52-5.52A5.52,5.52,0,0,1,564.55,293.28Zm0-10a4.52,4.52,0,1,0,4.52,4.52A4.53,4.53,0,0,0,564.55,283.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "564.55px 287.76px"
    },
    id: "elaa6ak2xd57a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.74,
    y: 230.61,
    width: 150.52,
    height: 6.3,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "556px 233.76px"
    },
    id: "elijeeqvhj5nl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.76,237.41H480.24v-7.3H631.76Zm-150.52-1H630.76v-5.3H481.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "556px 233.76px"
    },
    id: "ely1fahdc0w7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.35,
    cy: 233.28,
    r: 1.45,
    style: {
      fill: "#477BF0",
      transformOrigin: "486.35px 233.28px"
    },
    id: "elrlxbe2lz9wc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.86,
    cy: 233.28,
    r: 1.45,
    style: {
      fill: "#477BF0",
      transformOrigin: "492.86px 233.28px"
    },
    id: "el9o6w1ttszic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.83,233.28a1.45,1.45,0,1,1-1.45-1.45A1.45,1.45,0,0,1,500.83,233.28Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "499.38px 233.28px"
    },
    id: "el81gag23arnd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.83,302.43H494.26a1.6,1.6,0,0,1-1.6-1.6h0a1.6,1.6,0,0,1,1.6-1.6H618.83a1.6,1.6,0,0,1,1.6,1.6h0A1.6,1.6,0,0,1,618.83,302.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "556.545px 300.83px"
    },
    id: "elcmfeofegl3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.83,302.93H494.26a2.1,2.1,0,1,1,0-4.2H618.83a2.1,2.1,0,0,1,0,4.2Zm-124.57-3.2a1.1,1.1,0,1,0,0,2.2H618.83a1.1,1.1,0,0,0,0-2.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "556.545px 300.83px"
    },
    id: "elrw71e363ja8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582,299.23h-87.7a1.6,1.6,0,1,0,0,3.2H582Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "537.35px 300.83px"
    },
    id: "elwo7s7a2d5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.46,302.93h-88.2a2.1,2.1,0,1,1,0-4.2h88.2Zm-88.2-3.2a1.1,1.1,0,1,0,0,2.2h87.2v-2.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "537.31px 300.83px"
    },
    id: "eldbll4rofde8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.13,252.3c0-2.54,1.33-4,3.78-4s3.79,1.45,3.79,4v8.25c0,2.54-1.34,4-3.79,4s-3.78-1.45-3.78-4Zm2.49,8.41c0,1.14.5,1.57,1.29,1.57s1.3-.43,1.3-1.57v-8.57c0-1.13-.5-1.56-1.3-1.56s-1.29.43-1.29,1.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "493.915px 256.425px"
    },
    id: "el8h6w0jp3ku9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.7,252.41v2.07c0,2.54-1.22,3.92-3.72,3.92H501.8v6h-2.49V248.49H503C505.48,248.49,506.7,249.88,506.7,252.41Zm-4.9-1.65v5.37H503c.8,0,1.23-.36,1.23-1.49v-2.38c0-1.14-.43-1.5-1.23-1.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "503.005px 256.445px"
    },
    id: "el8q9382s1tnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.47,255.18h3.42v2.27h-3.42v4.65h4.3v2.26H508V248.49h6.8v2.27h-4.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "511.4px 256.425px"
    },
    id: "eltdfh1flxo2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.53,264.36a5,5,0,0,1-.22-1.95v-2.49c0-1.47-.5-2-1.64-2h-.86v6.46h-2.49V248.49h3.76c2.59,0,3.7,1.2,3.7,3.65v1.25c0,1.63-.52,2.7-1.63,3.22,1.24.52,1.65,1.72,1.65,3.38v2.45a4.63,4.63,0,0,0,.27,1.92Zm-2.72-13.6v4.87h1c.93,0,1.49-.4,1.49-1.67v-1.57c0-1.13-.38-1.63-1.27-1.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "520.195px 256.435px"
    },
    id: "elg9vlpthlbda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.51,264.36H531l-.43-2.88H527.5l-.43,2.88h-2.29l2.54-15.87H531Zm-5.7-5h2.41l-1.2-8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "529.145px 256.425px"
    },
    id: "el1g8fa82rwku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.94,248.49h7.71v2.27H539v13.6h-2.49v-13.6h-2.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "537.775px 256.425px"
    },
    id: "elkyi3go3v61f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.74,248.49h2.49v15.87h-2.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "543.985px 256.425px"
    },
    id: "elha3zwh4ekkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.27,252.87v11.49H547V248.49h3.13l2.56,9.5v-9.5h2.23v15.87h-2.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "550.96px 256.425px"
    },
    id: "elh5n4q9xlo3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.47,255.52H564v5c0,2.54-1.27,4-3.72,4s-3.72-1.45-3.72-4V252.3c0-2.54,1.27-4,3.72-4s3.72,1.45,3.72,4v1.54H561.6v-1.7c0-1.13-.5-1.56-1.29-1.56S559,251,559,252.14v8.57c0,1.14.5,1.54,1.29,1.54s1.29-.4,1.29-1.54v-2.92h-1.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "560.28px 256.41px"
    },
    id: "elxcqgj8bg8mg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.44,248.31c2.43,0,3.68,1.45,3.68,4v.5h-2.36v-.66c0-1.13-.46-1.56-1.25-1.56s-1.25.43-1.25,1.56c0,3.27,4.88,3.88,4.88,8.41,0,2.54-1.27,4-3.72,4s-3.72-1.45-3.72-4v-1h2.36v1.13c0,1.14.5,1.54,1.29,1.54s1.29-.4,1.29-1.54c0-3.26-4.87-3.87-4.87-8.41C568.77,249.76,570,248.31,572.44,248.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "572.42px 256.435px"
    },
    id: "el7tctzq221oh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.74,259.1l-3.15-10.61h2.61l1.9,7.23,1.91-7.23h2.38l-3.15,10.61v5.26h-2.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "580.99px 256.425px"
    },
    id: "ela24n999a24n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.59,248.31c2.42,0,3.67,1.45,3.67,4v.5H590.9v-.66c0-1.13-.45-1.56-1.24-1.56s-1.25.43-1.25,1.56c0,3.27,4.87,3.88,4.87,8.41,0,2.54-1.27,4-3.72,4s-3.71-1.45-3.71-4v-1h2.35v1.13c0,1.14.5,1.54,1.3,1.54s1.29-.4,1.29-1.54c0-3.26-4.88-3.87-4.88-8.41C585.91,249.76,587.16,248.31,589.59,248.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "589.565px 256.435px"
    },
    id: "elg1q7a6gyfwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594,248.49h7.71v2.27h-2.61v13.6h-2.5v-13.6H594Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "597.855px 256.425px"
    },
    id: "elg2h3mnsvfz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.28,255.18h3.42v2.27h-3.42v4.65h4.31v2.26h-6.8V248.49h6.8v2.27h-4.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "606.19px 256.425px"
    },
    id: "eltporyib4udr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.41,259.76l1.7-11.27h3.47v15.87h-2.36V253l-1.72,11.38h-2.36l-1.86-11.22v11.22h-2.17V248.49h3.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "616.345px 256.435px"
    },
    id: "el8u6qmm38y5",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-195",
    className: "animable",
    style: {
      transformOrigin: "116.64px 311.375px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.43,
    y: 354.25,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "190.695px 360.245px"
    },
    id: "el7avyn771wl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.46,366.74h-5.53v-13h5.53Zm-4.53-1h3.53v-11h-3.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.695px 360.24px"
    },
    id: "elta81czkju2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.74,
    y: 176.25,
    width: 129.69,
    height: 270.25,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.585px 311.375px"
    },
    id: "elt4b3krsk86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.93,447H66.24V175.75H196.93ZM67.24,446H195.93V176.75H67.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.585px 311.375px"
    },
    id: "elttwlilr8cz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.12,
    y: 424.98,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "69.385px 430.975px"
    },
    id: "el7leh9wiwcxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,437.47H66.62v-13h5.53Zm-4.53-1h3.53v-11H67.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "69.385px 430.97px"
    },
    id: "ela1xidgfblew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.46,
    y: 284.87,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.725px 290.865px"
    },
    id: "elzyaz8f5471",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,297.36H66v-13h5.53Zm-4.53-1h3.53v-11H67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.765px 290.86px"
    },
    id: "elx5ig97vtxv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.46,
    y: 390.07,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.725px 396.065px"
    },
    id: "ellv6gyddykw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,402.56H66v-13h5.53Zm-4.53-1h3.53v-11H67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.765px 396.06px"
    },
    id: "els5kjwqsgfub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.46,
    y: 354.18,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.725px 360.175px"
    },
    id: "ely9lv4hgu4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,366.66H66v-13h5.53Zm-4.53-1h3.53v-11H67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.765px 360.16px"
    },
    id: "el015xy6pgykla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.46,
    y: 319.46,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.725px 325.455px"
    },
    id: "el3pjr70gpaav",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,332H66V319h5.53ZM67,331h3.53V320H67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.765px 325.5px"
    },
    id: "elkba6g0bufa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.43,
    y: 424.98,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "190.695px 430.975px"
    },
    id: "eliw21v97h2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.46,437.47h-5.53v-13h5.53Zm-4.53-1h3.53v-11h-3.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.695px 430.97px"
    },
    id: "el2ria9a62wa2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.59,
    y: 284.87,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "191.855px 290.865px"
    },
    id: "ela2mxn30nfhv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,297.36h-5.53v-13h5.53Zm-4.53-1h3.53v-11h-3.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "191.855px 290.86px"
    },
    id: "el5dc0hnto3qn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.59,
    y: 390.07,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "191.855px 396.065px"
    },
    id: "el7lqnlovyjvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,402.56h-5.53v-13h5.53Zm-4.53-1h3.53v-11h-3.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "191.855px 396.06px"
    },
    id: "elcazu70ujcu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.59,
    y: 319.46,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "191.855px 325.455px"
    },
    id: "elsb1ew25djm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,332h-5.53V319h5.53Zm-4.53-1h3.53V320h-3.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "191.855px 325.5px"
    },
    id: "ellqhgl0tutd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.56,
    y: 278.24,
    width: 119.36,
    height: 25.85,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.24px 291.165px"
    },
    id: "elup0gxpopj5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,304.59H70.06V277.74H190.42Zm-119.36-1H189.42V278.74H71.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 291.165px"
    },
    id: "elq5oracsg7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 284.84,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "99.22px 291.17px"
    },
    id: "ele0w7tlse284",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,298H95.81a.5.5,0,0,1-.5-.5V284.84a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5V297.5A.5.5,0,0,1,102.63,298Zm-6.32-1h5.82V285.34H96.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.22px 291.17px"
    },
    id: "el3janf7hbfih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.36,
    y: 284.84,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "88.77px 291.17px"
    },
    id: "elm2n0bra3fi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,298H85.36a.5.5,0,0,1-.5-.5V284.84a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5V297.5A.5.5,0,0,1,92.18,298Zm-6.32-1h5.82V285.34H85.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.77px 291.17px"
    },
    id: "elvcuny1yzka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3,
    y: 284.84,
    width: 5.43,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "79.015px 291.17px"
    },
    id: "el8c5l8nclng8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,298H76.3a.5.5,0,0,1-.5-.5V284.84a.5.5,0,0,1,.5-.5h5.43a.5.5,0,0,1,.5.5V297.5A.5.5,0,0,1,81.73,298Zm-4.93-1h4.43V285.34H76.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.015px 291.17px"
    },
    id: "el86wznus2cuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 284.84,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "109.67px 291.17px"
    },
    id: "el8cyactwg2mx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,298h-6.81a.5.5,0,0,1-.5-.5V284.84a.5.5,0,0,1,.5-.5h6.81a.5.5,0,0,1,.5.5V297.5A.5.5,0,0,1,113.08,298Zm-6.31-1h5.81V285.34h-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.675px 291.17px"
    },
    id: "elvsz60tberol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.71,
    y: 284.84,
    width: 41.85,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "137.635px 291.17px"
    },
    id: "el7cz9posnxzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,298H116.71a.5.5,0,0,1-.5-.5V284.84a.5.5,0,0,1,.5-.5h41.85a.5.5,0,0,1,.5.5V297.5A.5.5,0,0,1,158.56,298Zm-41.35-1h40.85V285.34H117.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.635px 291.17px"
    },
    id: "elwqgdfh3rq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89,290.62a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,172.89,290.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.7px 290.62px"
    },
    id: "eliibo24nnn6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,294.31a3.69,3.69,0,1,1,3.69-3.69A3.7,3.7,0,0,1,169.7,294.31Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.69,2.69,0,0,0,169.7,287.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.7px 290.62px"
    },
    id: "elzwnru0wiu5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,290.62a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,185.39,290.62Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "182.2px 290.62px"
    },
    id: "elb75p5bxl7he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,294.31a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,182.2,294.31Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.68,2.68,0,0,0,182.2,287.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.2px 290.62px"
    },
    id: "elvc1gdhorg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.28,290.62a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,154.28,290.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "151.09px 290.62px"
    },
    id: "el5qn476st1wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,294.31a3.69,3.69,0,1,1,3.69-3.69A3.7,3.7,0,0,1,151.09,294.31Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.69,2.69,0,0,0,151.09,287.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.09px 290.62px"
    },
    id: "el6tbvk6pytf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.46,
    y: 249.64,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.725px 255.635px"
    },
    id: "elcu4qkaw8v8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,262.12H66v-13h5.53Zm-4.53-1h3.53v-11H67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.765px 255.62px"
    },
    id: "elpqgf76cz6n9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.59,
    y: 249.64,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "191.855px 255.635px"
    },
    id: "el7lm6bmbxuyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,262.12h-5.53v-13h5.53Zm-4.53-1h3.53v-11h-3.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "191.855px 255.62px"
    },
    id: "el0ejt66c44l7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.56,
    y: 243,
    width: 119.36,
    height: 25.85,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.24px 255.925px"
    },
    id: "elw5pftcyvoal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,269.36H70.06V242.5H190.42Zm-119.36-1H189.42V243.5H71.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 255.93px"
    },
    id: "el61zdsiszrt3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 249.6,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "99.22px 255.93px"
    },
    id: "elh4iuqdlxswv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,262.76H95.81a.5.5,0,0,1-.5-.5V249.6a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,102.63,262.76Zm-6.32-1h5.82V250.1H96.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.22px 255.93px"
    },
    id: "elcrbmetsono",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.36,
    y: 249.6,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "88.77px 255.93px"
    },
    id: "elcrac8xud9mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,262.76H85.36a.5.5,0,0,1-.5-.5V249.6a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,92.18,262.76Zm-6.32-1h5.82V250.1H85.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.77px 255.93px"
    },
    id: "el67iq5rqiiti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3,
    y: 249.6,
    width: 5.43,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "79.015px 255.93px"
    },
    id: "el12irlgd6o91r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,262.76H76.3a.5.5,0,0,1-.5-.5V249.6a.5.5,0,0,1,.5-.5h5.43a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,81.73,262.76Zm-4.93-1h4.43V250.1H76.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.015px 255.93px"
    },
    id: "elvtkb27hx8sp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 249.6,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "109.67px 255.93px"
    },
    id: "eljkvrmssvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,262.76h-6.81a.5.5,0,0,1-.5-.5V249.6a.5.5,0,0,1,.5-.5h6.81a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,113.08,262.76Zm-6.31-1h5.81V250.1h-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.675px 255.93px"
    },
    id: "eld0qr7tq48jk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.71,
    y: 249.6,
    width: 41.85,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "137.635px 255.93px"
    },
    id: "elcka7fduobtk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,262.76H116.71a.5.5,0,0,1-.5-.5V249.6a.5.5,0,0,1,.5-.5h41.85a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,158.56,262.76Zm-41.35-1h40.85V250.1H117.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.635px 255.93px"
    },
    id: "elpvi3ocpftm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.7,
    cy: 255.38,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.7px 255.38px"
    },
    id: "eleqhiey00qxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,259.07a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,169.7,259.07Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,169.7,252.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.7px 255.38px"
    },
    id: "elz7es1k0epr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,255.38a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,185.39,255.38Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "182.2px 255.38px"
    },
    id: "el513q2943taw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,259.07a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,182.2,259.07Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.69,2.69,0,0,0,182.2,252.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.2px 255.38px"
    },
    id: "el78w6xtgnkab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.09,
    cy: 255.38,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "151.09px 255.38px"
    },
    id: "elr3vpu3eh587",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,259.07a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,151.09,259.07Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,151.09,252.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.09px 255.38px"
    },
    id: "elzdeyztjkzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.46,
    y: 214.4,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.725px 220.395px"
    },
    id: "elv0rne4xa9cm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,226.89H66v-13h5.53Zm-4.53-1h3.53v-11H67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.765px 220.39px"
    },
    id: "elynejq9mxzrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.59,
    y: 214.4,
    width: 4.53,
    height: 11.99,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "191.855px 220.395px"
    },
    id: "elxp5p9fv7v1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,226.89h-5.53v-13h5.53Zm-4.53-1h3.53v-11h-3.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "191.855px 220.39px"
    },
    id: "el3n8h8b4f7fn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.56,
    y: 207.77,
    width: 119.36,
    height: 25.85,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.24px 220.695px"
    },
    id: "el2ynd2i15fan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,234.12H70.06V207.27H190.42Zm-119.36-1H189.42V208.27H71.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 220.695px"
    },
    id: "eli7xf3l01399",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 214.36,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "99.22px 220.69px"
    },
    id: "el0lg52bwntcwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,227.52H95.81a.5.5,0,0,1-.5-.5V214.36a.51.51,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5V227A.5.5,0,0,1,102.63,227.52Zm-6.32-1h5.82V214.86H96.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.2202px 220.69px"
    },
    id: "elex01c4p4kzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.36,
    y: 214.36,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "88.77px 220.69px"
    },
    id: "ellb4dintqyjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,227.52H85.36a.5.5,0,0,1-.5-.5V214.36a.51.51,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5V227A.5.5,0,0,1,92.18,227.52Zm-6.32-1h5.82V214.86H85.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.7702px 220.69px"
    },
    id: "elxmqbrwd0nj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3,
    y: 214.36,
    width: 5.43,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "79.015px 220.69px"
    },
    id: "eltnutncsa8cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,227.52H76.3a.5.5,0,0,1-.5-.5V214.36a.5.5,0,0,1,.5-.5h5.43a.5.5,0,0,1,.5.5V227A.5.5,0,0,1,81.73,227.52Zm-4.93-1h4.43V214.86H76.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.0152px 220.69px"
    },
    id: "els3vwhxobbhj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 214.36,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "109.67px 220.69px"
    },
    id: "elrtt04prtys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,227.52h-6.81a.5.5,0,0,1-.5-.5V214.36a.5.5,0,0,1,.5-.5h6.81a.5.5,0,0,1,.5.5V227A.5.5,0,0,1,113.08,227.52Zm-6.31-1h5.81V214.86h-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.675px 220.69px"
    },
    id: "elq3k3bpmpnfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.71,
    y: 214.36,
    width: 41.85,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "137.635px 220.69px"
    },
    id: "el6dpv1rtzjss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,227.52H116.71a.5.5,0,0,1-.5-.5V214.36a.51.51,0,0,1,.5-.5h41.85a.5.5,0,0,1,.5.5V227A.5.5,0,0,1,158.56,227.52Zm-41.35-1h40.85V214.86H117.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.635px 220.69px"
    },
    id: "elsl9lzeng7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.7,
    cy: 220.14,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.7px 220.14px"
    },
    id: "el4p3bx89tjl6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,223.83a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,169.7,223.83Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,169.7,217.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.7px 220.14px"
    },
    id: "elyl1wjxzb4fb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,220.14a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,185.39,220.14Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "182.2px 220.14px"
    },
    id: "el3nxo0j57hn3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,223.83a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,182.2,223.83Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.69,2.69,0,0,0,182.2,217.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.2px 220.14px"
    },
    id: "ellj3x3api8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.09,
    cy: 220.14,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "151.09px 220.14px"
    },
    id: "el0zcfkimtgkye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,223.83a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,151.09,223.83Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,151.09,217.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.09px 220.14px"
    },
    id: "elnzl3yxspoqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.09,
    y: 304.09,
    width: 110.3,
    height: 8.85,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 308.515px"
    },
    id: "eldgboqp111bi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,313.45H74.59v-9.86h111.3Zm-110.3-1h109.3v-7.86H75.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 308.52px"
    },
    id: "elrkz3p4weqkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.56,
    y: 312.95,
    width: 119.36,
    height: 25.85,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.24px 325.875px"
    },
    id: "ell6b0p0bxord",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,339.3H70.06V312.45H190.42Zm-119.36-1H189.42V313.45H71.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 325.875px"
    },
    id: "elevg3q3llgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.36,
    y: 319.54,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "88.77px 325.87px"
    },
    id: "elfbhl1i4pby",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,332.71H85.36a.51.51,0,0,1-.5-.5V319.54a.51.51,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.67A.5.5,0,0,1,92.18,332.71Zm-6.32-1h5.82V320H85.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.77px 325.875px"
    },
    id: "el37wdfflhq8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 319.54,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "109.67px 325.87px"
    },
    id: "ele7fv7me8qcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,332.71h-6.81a.5.5,0,0,1-.5-.5V319.54a.5.5,0,0,1,.5-.5h6.81a.5.5,0,0,1,.5.5v12.67A.5.5,0,0,1,113.08,332.71Zm-6.31-1h5.81V320h-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.675px 325.875px"
    },
    id: "ellwegery9hk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 319.54,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "99.22px 325.87px"
    },
    id: "elkoc3wio6ab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,332.71H95.81a.51.51,0,0,1-.5-.5V319.54a.51.51,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.67A.5.5,0,0,1,102.63,332.71Zm-6.32-1h5.82V320H96.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.22px 325.875px"
    },
    id: "elt7qjws275b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3,
    y: 319.54,
    width: 5.43,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "79.015px 325.87px"
    },
    id: "elnolrgtr5pmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,332.71H76.3a.5.5,0,0,1-.5-.5V319.54a.5.5,0,0,1,.5-.5h5.43a.5.5,0,0,1,.5.5v12.67A.5.5,0,0,1,81.73,332.71Zm-4.93-1h4.43V320H76.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.015px 325.875px"
    },
    id: "el1sqbwj3v1fb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.71,
    y: 319.54,
    width: 41.85,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "137.635px 325.87px"
    },
    id: "el6d00n6onewb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,332.71H116.71a.51.51,0,0,1-.5-.5V319.54a.51.51,0,0,1,.5-.5h41.85a.5.5,0,0,1,.5.5v12.67A.5.5,0,0,1,158.56,332.71Zm-41.35-1h40.85V320H117.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.635px 325.875px"
    },
    id: "elkgjs68jl3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.7,
    cy: 325.32,
    r: 3.19,
    style: {
      fill: "#477BF0",
      transformOrigin: "169.7px 325.32px"
    },
    id: "elg3amxm3fkc7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,329a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,169.7,329Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,169.7,322.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.7px 325.31px"
    },
    id: "eloaj06n68uyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,325.32a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,185.39,325.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "182.2px 325.32px"
    },
    id: "elgpak244ghpu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,329a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,182.2,329Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.69,2.69,0,0,0,182.2,322.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.2px 325.31px"
    },
    id: "el5il22pbtlio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.09,
    cy: 325.32,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "151.09px 325.32px"
    },
    id: "elk3ua175bwq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,329a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,151.09,329Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,151.09,322.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.09px 325.31px"
    },
    id: "elldob3f5snfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.09,
    y: 338.8,
    width: 110.3,
    height: 8.85,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 343.225px"
    },
    id: "eld3ovxz8ylbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,348.15H74.59V338.3h111.3Zm-110.3-1h109.3V339.3H75.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 343.225px"
    },
    id: "elo7qqxly85xe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.56,
    y: 347.65,
    width: 119.36,
    height: 25.85,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.24px 360.575px"
    },
    id: "elj2qn4bs40r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,374H70.06V347.15H190.42ZM71.06,373H189.42V348.15H71.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 360.575px"
    },
    id: "el3z7zsmuky3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 354.25,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "99.22px 360.58px"
    },
    id: "ell8zv864m77",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,367.41H95.81a.5.5,0,0,1-.5-.5V354.25a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,102.63,367.41Zm-6.32-1h5.82V354.75H96.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.22px 360.58px"
    },
    id: "el5x05hahwtfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 354.25,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "109.67px 360.58px"
    },
    id: "eln6ggyxqsjsc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,367.41h-6.81a.5.5,0,0,1-.5-.5V354.25a.5.5,0,0,1,.5-.5h6.81a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,113.08,367.41Zm-6.31-1h5.81V354.75h-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.675px 360.58px"
    },
    id: "el0kg06xz8xs5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.36,
    y: 354.25,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "88.77px 360.58px"
    },
    id: "el4q3tcl92knl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,367.41H85.36a.5.5,0,0,1-.5-.5V354.25a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,92.18,367.41Zm-6.32-1h5.82V354.75H85.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.77px 360.58px"
    },
    id: "eldn0ssmsd3dl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.71,
    y: 354.25,
    width: 41.85,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "137.635px 360.58px"
    },
    id: "elzl3wkvgmjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,367.41H116.71a.5.5,0,0,1-.5-.5V354.25a.5.5,0,0,1,.5-.5h41.85a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,158.56,367.41Zm-41.35-1h40.85V354.75H117.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.635px 360.58px"
    },
    id: "elxktkgi7168n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3,
    y: 354.25,
    width: 5.43,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "79.015px 360.58px"
    },
    id: "el6qb58k4q5zw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,367.41H76.3a.5.5,0,0,1-.5-.5V354.25a.5.5,0,0,1,.5-.5h5.43a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,81.73,367.41Zm-4.93-1h4.43V354.75H76.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.015px 360.58px"
    },
    id: "el9vdskupjtr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.7,
    cy: 360.03,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.7px 360.03px"
    },
    id: "elis7kf4um8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,363.72a3.69,3.69,0,1,1,3.69-3.69A3.7,3.7,0,0,1,169.7,363.72Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,169.7,357.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.7px 360.03px"
    },
    id: "elogwj3b5yo0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,360a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,185.39,360Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "182.2px 360px"
    },
    id: "el4gwxf0um58u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,363.72a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,182.2,363.72Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.69,2.69,0,0,0,182.2,357.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.2px 360.03px"
    },
    id: "else8gbna625c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.09,
    cy: 360.03,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "151.09px 360.03px"
    },
    id: "elfowqw0u6wod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,363.72a3.69,3.69,0,1,1,3.69-3.69A3.7,3.7,0,0,1,151.09,363.72Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,151.09,357.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.09px 360.03px"
    },
    id: "elwhwt56cviqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.09,
    y: 373.51,
    width: 110.3,
    height: 8.85,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 377.935px"
    },
    id: "elg58wmdb4cdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,382.86H74.59V373h111.3Zm-110.3-1h109.3V374H75.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 377.93px"
    },
    id: "el0x1z15pz4oz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.56,
    y: 382.36,
    width: 119.36,
    height: 25.85,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.24px 395.285px"
    },
    id: "elded0pr74ff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,408.71H70.06V381.86H190.42Zm-119.36-1H189.42V382.86H71.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 395.285px"
    },
    id: "elsk120io8k1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 388.95,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "109.67px 395.28px"
    },
    id: "el1yqs4mfuzga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,402.12h-6.81a.5.5,0,0,1-.5-.5V389a.5.5,0,0,1,.5-.5h6.81a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,113.08,402.12Zm-6.31-1h5.81V389.46h-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.675px 395.31px"
    },
    id: "elt8qqfifhamq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.36,
    y: 388.95,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "88.77px 395.28px"
    },
    id: "elg6pn3slyxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,402.12H85.36a.51.51,0,0,1-.5-.5V389a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,92.18,402.12Zm-6.32-1h5.82V389.46H85.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.77px 395.31px"
    },
    id: "elqmocbpvrsj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 388.95,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "99.22px 395.28px"
    },
    id: "elmnlivb0jmya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,402.12H95.81a.51.51,0,0,1-.5-.5V389a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,102.63,402.12Zm-6.32-1h5.82V389.46H96.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.22px 395.31px"
    },
    id: "elfhi77livsc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3,
    y: 388.95,
    width: 5.43,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "79.015px 395.28px"
    },
    id: "el18qvyp7wrbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,402.12H76.3a.5.5,0,0,1-.5-.5V389a.5.5,0,0,1,.5-.5h5.43a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,81.73,402.12Zm-4.93-1h4.43V389.46H76.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.015px 395.31px"
    },
    id: "elrdab5dpo2z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.71,
    y: 388.95,
    width: 41.85,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "137.635px 395.28px"
    },
    id: "el4qtthlnwigx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,402.12H116.71a.51.51,0,0,1-.5-.5V389a.5.5,0,0,1,.5-.5h41.85a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,158.56,402.12Zm-41.35-1h40.85V389.46H117.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.635px 395.31px"
    },
    id: "elw6eww5n40x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.7,
    cy: 394.73,
    r: 3.19,
    style: {
      fill: "#477BF0",
      transformOrigin: "169.7px 394.73px"
    },
    id: "el9wlo5obrpvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,398.42a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,169.7,398.42Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,169.7,392Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.7px 394.73px"
    },
    id: "elu8tu9i8w9rs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,394.73a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,185.39,394.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "182.2px 394.73px"
    },
    id: "eltdsxh0qn9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,398.42a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,182.2,398.42Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.69,2.69,0,0,0,182.2,392Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.2px 394.73px"
    },
    id: "eldix8twy7lh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.09,
    cy: 394.73,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "151.09px 394.73px"
    },
    id: "elkojk5bxbdsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,398.42a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,151.09,398.42Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,151.09,392Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.09px 394.73px"
    },
    id: "elez88bqemtaw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.09,
    y: 408.21,
    width: 110.3,
    height: 8.85,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 412.635px"
    },
    id: "elfe5bj2ptomv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,417.57H74.59v-9.86h111.3Zm-110.3-1h109.3v-7.86H75.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 412.64px"
    },
    id: "elnw6ea5p63bh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.56,
    y: 417.07,
    width: 119.36,
    height: 25.85,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.24px 429.995px"
    },
    id: "elsx29cw9qp7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,443.42H70.06V416.57H190.42Zm-119.36-1H189.42V417.57H71.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.24px 429.995px"
    },
    id: "el6hybfmvsetw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.36,
    y: 423.66,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "88.77px 429.99px"
    },
    id: "el9qxkhxqrie4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,436.82H85.36a.5.5,0,0,1-.5-.5V423.66a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,92.18,436.82Zm-6.32-1h5.82V424.16H85.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.77px 429.99px"
    },
    id: "elfr41zhx56up",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 423.66,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "99.22px 429.99px"
    },
    id: "elhtl3vu141ft",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,436.82H95.81a.5.5,0,0,1-.5-.5V423.66a.5.5,0,0,1,.5-.5h6.82a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,102.63,436.82Zm-6.32-1h5.82V424.16H96.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.22px 429.99px"
    },
    id: "eljo8cy3q8h3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.26,
    y: 423.66,
    width: 6.82,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "109.67px 429.99px"
    },
    id: "elnighyfntfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.08,436.82h-6.81a.5.5,0,0,1-.5-.5V423.66a.5.5,0,0,1,.5-.5h6.81a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,113.08,436.82Zm-6.31-1h5.81V424.16h-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.675px 429.99px"
    },
    id: "el23h75kib5wr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3,
    y: 423.66,
    width: 5.43,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "79.015px 429.99px"
    },
    id: "elgtt6i5kqvqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,436.82H76.3a.5.5,0,0,1-.5-.5V423.66a.5.5,0,0,1,.5-.5h5.43a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,81.73,436.82Zm-4.93-1h4.43V424.16H76.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.015px 429.99px"
    },
    id: "el9snibwds76o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.71,
    y: 423.66,
    width: 41.85,
    height: 12.66,
    style: {
      fill: "#477BF0",
      transformOrigin: "137.635px 429.99px"
    },
    id: "elggo4ktktdqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,436.82H116.71a.5.5,0,0,1-.5-.5V423.66a.5.5,0,0,1,.5-.5h41.85a.5.5,0,0,1,.5.5v12.66A.5.5,0,0,1,158.56,436.82Zm-41.35-1h40.85V424.16H117.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.635px 429.99px"
    },
    id: "ela8oe00ilrt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.7,
    cy: 429.44,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.7px 429.44px"
    },
    id: "el2frqbx8kczq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,433.13a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,169.7,433.13Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,169.7,426.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.7px 429.44px"
    },
    id: "el0gy81qilihbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,429.44a3.19,3.19,0,1,0-3.19,3.19A3.19,3.19,0,0,0,185.39,429.44Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "182.2px 429.44px"
    },
    id: "el2wdfkj3poy3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,433.13a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,182.2,433.13Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.69,2.69,0,0,0,182.2,426.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.2px 429.44px"
    },
    id: "el8m99qu4q807",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.09,
    cy: 429.44,
    r: 3.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "151.09px 429.44px"
    },
    id: "elizwf0h7d9y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,433.13a3.69,3.69,0,1,1,3.69-3.69A3.69,3.69,0,0,1,151.09,433.13Zm0-6.38a2.69,2.69,0,1,0,2.69,2.69A2.7,2.7,0,0,0,151.09,426.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.09px 429.44px"
    },
    id: "elkcvew6lxyzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.85,
    y: 176.25,
    width: 31.25,
    height: 270.18,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "52.475px 311.34px"
    },
    id: "el75zbbrxfr1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6,446.92H36.35V175.75H68.6Zm-31.25-1H67.6V176.75H37.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "52.475px 311.335px"
    },
    id: "elph8hrn4uqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.46,432.14h-22V182.45h22Zm-21-1h20V183.45h-20Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "52.46px 307.295px"
    },
    id: "el74f7rfn0ei3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.74,
    cy: 193.45,
    r: 3.46,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "81.74px 193.45px"
    },
    id: "elo7g4nk6aly",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.18,
    cy: 193.45,
    r: 3.46,
    style: {
      fill: "#477BF0",
      transformOrigin: "94.18px 193.45px"
    },
    id: "elyb1ozlk1b4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.18,197.41a4,4,0,1,1,4-4A4,4,0,0,1,94.18,197.41Zm0-6.91a3,3,0,1,0,3,2.95A2.95,2.95,0,0,0,94.18,190.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.18px 193.41px"
    },
    id: "elbf57skrkqle",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-1--inject-195",
    className: "animable",
    style: {
      transformOrigin: "328.225px 141.089px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287,166.28l9.51-50.4h12.7l9.39,50.4H308.35l-1.68-10.64h-7.4l-1.74,10.64ZM300.27,149h5.35l-2.68-19.66Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "302.8px 141.08px"
    },
    id: "el0wo8hkikn9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.22,166.28v-50.4h16.92a14.54,14.54,0,0,1,7.47,1.72,10.38,10.38,0,0,1,4.35,5,19.61,19.61,0,0,1,1.44,7.93c0,3.9-.65,6.88-1.93,8.93a10,10,0,0,1-5.23,4.26,21.76,21.76,0,0,1-7.4,1.18h-4.48v21.41Zm11.14-29.18h3.73a5.35,5.35,0,0,0,3.11-.75,3.58,3.58,0,0,0,1.4-2.24,17.28,17.28,0,0,0,.34-3.79,17.84,17.84,0,0,0-.28-3.39,3.86,3.86,0,0,0-1.33-2.34,5.17,5.17,0,0,0-3.3-.87h-3.67Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "338.314px 141.089px"
    },
    id: "el1n4covxpivl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.31,166.28v-50.4h11.14v50.4Z",
    style: {
      fill: "#477BF0",
      transformOrigin: "363.88px 141.08px"
    },
    id: "elvzrb57876ir",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2);
export default __webpack_public_path__ + "static/media/about2.fab63a8070bd31166c51fae84e329435.svg";
export { ForwardRef as ReactComponent };